// src/MapComponent.js
import React, { useEffect, useRef, useState } from 'react';
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { fromLonLat, transform } from 'ol/proj';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Feature } from 'ol';
import { Point, Polygon,LineString } from 'ol/geom';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import { Icon, Style, Stroke, Text } from 'ol/style';
import XYZ from 'ol/source/XYZ';
import TileWMS from 'ol/source/TileWMS';
import { FullScreen, ScaleLine, ZoomToExtent, defaults as defaultControls } from 'ol/control';
import Zoom from 'ol/control/Zoom';
import axios from "axios";
import { Overlay } from 'ol';
import shpwrite from "shp-write";
import { DOMParser } from "xmldom";
import { kml } from "@tmcw/togeojson";
import terrains from '../../assets/images/terrain_map_img.png'
import setelites from '../../assets/images/satellite_map_img.png'
import whitebg from '../../assets/images/white_bg.png'
import openstreet from '../../assets/images/open_street_map_img.png'
import layersicon from '../../assets/images/layers_icon.svg'
import { downloadSHPFileWithDetails } from './downloadSHPFileWithDetails';
import { handleMarkerClickCotton } from './handleMarkerClickCotton';
import { displaySchemeMapDetails } from './displaySchemeMapDetails';
import { YearlyChart } from './yearlyChartData';
import { SchemeStateLineChart } from './SchemeStateLineChart';
import { SchemePieChart } from './SchemePieChart';

import { KMLFileData } from './13All05032025.kml';
import KML from 'ol/format/KML';
import { MultiSelect } from "react-multi-select-component";
import { Link } from "react-router-dom";
import BlueMarker from '../../assets/images/icon/blue-dot.png';
import PurpleMarker from '../../assets/images/icon/purple-dot.png';
import YellowMarker from '../../assets/images/icon/yellow-dot.png';
import GreenMarker from '../../assets/images/icon/green-dot.png';
import MergentaMarker from '../../assets/images/icon/mergenta-dot.png';
import PinkMarker from '../../assets/images/icon/pink-dot.png';
import DarkGrayMarker from '../../assets/images/icon/darkgray-dot.png';
import DarkGreenMarker from '../../assets/images/icon/darkgreen-dot.png';
import LiteBlueMarker from '../../assets/images/icon/liteblue-dot.png';
import LitegreenMarker from '../../assets/images/icon/litegreen-dot.png';
import Draggable from 'react-draggable';

import LightPurpleMarker from '../../assets/images/icon/lightpurple-dot.png';
import DarkPurpleMarker from '../../assets/images/icon/darkpurple-dot.png';
import LightPinkMarker from '../../assets/images/icon/lightpink-dot.png';
import SuperDarkGreenMarker from '../../assets/images/icon/superdarkgreen-dot.png';

import PinkHomeMarker from '../../assets/images/icon/pink-home.png';
import GreenHomeMarker from '../../assets/images/icon/green-home.png';
import OrangeHomeMarker from '../../assets/images/icon/orange-home.png';
import BlueHomeMarker from '../../assets/images/icon/blue-home.png';
import PurpleHomeMarker from '../../assets/images/icon/purple-home.png';
import GrayHomeMarker from '../../assets/images/icon/gray-home.png';
import SkyBlueMarker from '../../assets/images/icon/skyblue-dot.png'
import number from "../../assets/images/number.png"

import BlueCircle from '../../assets/images/icon/Blue-Circle.png';
const MapComponent = () => {
      const [userVisible, setUserVisible] = useState(true);
    const [acabcFilter, setAcabcFilter] = useState("");
    const [statesData, setStatesData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [subDistrictData, setSubDistrictData] = useState([]);
    const [blockData, setBlockData] = useState([]);
    const [villageData, setVillageData] = useState([]);

    const [stateValue, setStateValue] = useState('');
    const [districtValue, setDistrictValue] = useState("");
    const [subDistrictValue, setSubDistrictValue] = useState("");
    const [blockValue, setBlockValue] = useState("");
    const [villageValue, setVillageValue] = useState("");
    const [apisuccess, setAPISucess] = useState(false)
    const [popup, setPopup] = useState(false);
    const [selectedPlot, setSelectedPlot] = useState(null);
    const [datasets, setDatasets] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState("NA");

    const [selected, setSelected] = useState([]);
    const [selectedNBHM, setSelectedNBHM] = useState([]);
    const [mandtFilter, setMandtFilter] = useState([]);
    const [filterCall, setFilterCall] = useState(false);
    const [loader, setLoader] = useState(false);
    const [ACABCData, setACABCData] = useState([]);
    const [ACABCPolygonData, setACABCPolygonData] = useState([]);
    const [AIFData, setAIFData] = useState([]);
    const [agroforestryData, setAgroforestryData] = useState([]);
    const [AMIData, setAMIData] = useState([]);
    const [MANDTData, setMANDTData] = useState([]);
    const [NBHMDataA, setNBHMDataA] = useState([]);
    const [NBHMDataB, setNBHMDataB] = useState([]);
    const [NBHMDataC, setNBHMDataC] = useState([]);
    const [NBHMDataD, setNBHMDataD] = useState([]);
    const [NFSMData, setNFSMData] = useState([]);
    const [NHBData, setNHBData] = useState([]);
    const [PDMCData, setPDMCData] = useState([]);
    const [RADData, setRADData] = useState([]);
    const [STLLabData, setSTLLabData] = useState([]);
    const [SHCFarmerData, setSHCFarmerData] = useState([]);
    const [cropicData, setCropicData] = useState([]);
    const [RKVYData, setRKVYData] = useState([]);
    const [NaturalFarmingData, setNaturalFarmingData] = useState([]);
    const [MIDHData, setMIDHData] = useState([]);
    const [MOVCDData, setMOVCDData] = useState([]);
    const [NPSSData, setNPSSData] = useState([]);
    const [CottonData, setCottonData] = useState([]);
    const [SeedHubData, setSeedHubData] = useState([]);
    const [CDBData, setCDBData] = useState([]);
    const [DASDData, setDASDData] = useState([]);
    const [LoaderCDB, setLoaderCDB] = useState(false);
    const [LoaderDASD, setLoaderDASD] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showSelectedScheme, setShowSelectedScheme] = useState("");
    const [missingSchemes, setMissingSchemes] = useState([]);
    const [visible, setVisible] = useState(true);
    const [sechemeDropDown, setSechemeDropDown] = useState(0);
    const [topStates, setTopStates] = useState([]);
    const [isTopStatesModalOpen, setIsTopStatesModalOpen] = useState(false);
    const [showAnalytics, setShowAnalytics] = useState(false);
      const [expanded, setExpanded] = useState(false);
      const has29 = datasets.some(d => d.selectedValue === "29");
    const [selectedScheme, setSelectedScheme] = useState("1"); // Default to ACABC


    const optionsScheme = [
        { value: "1", label: "ACABC" },
        { value: "2", label: "AgroForestry" },
        { value: "3", label: "AIF" },
        { value: "40", label: "AMI" },
        { value: "4", label: "Agriculture Marketing-AMI" },
        { value: "5", label: "M&T-CHC" },
        { value: "6", label: "NBHM" },
        { value: "7", label: "NFSM-CFLD" },
        { value: "8", label: "NHB-Inspection" },
        //  { value: "9", label: "NMEO" },
        { value: "10", label: "PDMC" },
        { value: "11", label: "RAD" },
        { value: "12", label: "Soil Testing Lab" },
        { value: "13", label: "SHC-Farmer" },
        { value: "14", label: "Cropic" },
        { value: "15", label: "RKVY(API)" },
        // { value: "16", label: "Natural Farming" },
        { value: "17", label: "MIDH" },
        { value: "18", label: "MOVCD" },
        { value: "19", label: "NPSS" },
        { value: "20", label: "NFSM-HDPS Cotton" },
        { value: "21", label: "Seed Hub" },
        { value: "22", label: "Cocunut Development Board (CDB)" },
        { value: "23", label: "Directorate of Arecanut and Spices Development (DASD)" },
       ,
        { value: "26", label: "GT"},
        { value: "29", label: "NMEO-OP"},
        { value: "31", label: "NMEO-OS"},
        { value: "30", label: "RKVY(Krishi Mapper)"}
      /*  { value: "25", label: "KE Cultivation Pvt Ltd" },*/
        // { value: "25", label: "NMEO 3F Conversion Details " },
        // { value: "26", label: "NMEO 3F Godrej" },

    ];

    const optionsNBHM = [
        { value: "1", label: "Honey Processing Unit" },
        { value: "2", label: "Honey Testing Unit" },
        { value: "3", label: "Honey CHC" },
        { value: "4", label: "Beeflora Plantation" },
    ];
const [NBHMData, setNBHMData] = useState({
  A: { 
    label: "Honey Processing Unit",
    data: [],
    marker: DarkGreenMarker
  },
  B: {
    label: "Honey Testing Unit", 
    data: [],
    marker: BlueMarker
  },
  C: {
    label: "Honey CHC",
    data: [],
    marker: LitegreenMarker
  },
  D: {
    label: "Beeflora Plantation",
    data: [],
    marker: LightPurpleMarker
  }
});
    const [csvArrayData, setCsvArrayData] = useState([{ Scheme: "ACABC", TotalCount: 0 }, { Scheme: "NFSM-CFLD", TotalCount: 0 }, { Scheme: "SHC-Farmer", TotalCount: 0 }]);
    const [featuresLayer, setFeaturesLayer] = useState(null); // Initialize features layer to null
    const [center, setCenter] = useState({
        lat: 21.977434,
        lng: 78.283474,
    });

function getStates() {
        const fetchStates = async () => {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            setStatesData(result.data.dataContent);
        };
        fetchStates();
    }

    function handleState(value) {
    // Clear dependent values when state changes
    setStateValue(value);
    setDistrictData([]);
    setDistrictValue("");
    setSubDistrictValue("");

    if (value === "NA") {
        return;
    }

    // Fetch districts for selected state
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ stateCode: Number(value) }),
        redirect: "follow",
    };

    fetch(
        `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/district`,
        requestOptions
    )
        .then((response) => response.json())
        .then((result) => setDistrictData(result.dataContent))
        .catch((error) => console.error("Error fetching districts:", error));
}

// Initialize schemes in useEffect or separate function
useEffect(() => {
    if (selected.length === 0) {
        setSechemeDropDown('1');
        setSelected([
          //  { value: "1", label: "ACABC" },
            // ... rest of the schemes
        ]);
    }
}, []); // Empty dependency array to run only once on mount
    function downloadSHP(){

       downloadSHPFileWithDetails(datasets[0].responseArray);
    }


    function handleClear() {

        setSelected([]);
        setDatasets([]);
        setVillageValue("");
        setBlockValue("");
        setSubDistrictValue("");
        setDistrictValue("");
        setStateValue("");
        setVillageData([]);
        setBlockData([]);
        setSubDistrictData([]);
        setDistrictData([]);
        setStatesData([]);
        setSechemeDropDown(0)
       document.getElementById("infoDetailsCotton").style.display = "none";
       document.getElementById("counts").style.display = "none";

       setVisible(true);
    }

     function openMandtPopup(value) {

  const fetchMandTdata = async () => {

    let result;
    if(mandtFilter === "1") {
  
       result = await axios.post(`${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/Reverse/CommonAPI/Get_FMDBT_BYCHCPolygonIDHistory_GIS_Dashboard`, { "StrCHCHistoryUserID"  : value})

    }else {

       result = await axios.post(`${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/Reverse/CommonAPI/Get_FMDBT_BYCHCPolygonID_GIS_Dashboard`, { "strCHCUserid" : value})
    }
       
    if(result.data.data) {
      let filteredImageHtmlPre = `<table class="table table-bordered"><thead><tr> <th>S.No</th><th >Implement Name</th></tr></thead><tbody>`
      let  filteredImageHtml = result.data.data.map((item, index) => {
        return   `<tr key=${index}><th scope="row">${index +1}</th>  <td>${item.implementSubsidyName}</td> </tr>`
    }).join('');

    let fullInnerHTML = filteredImageHtmlPre+  filteredImageHtml + " </tbody> </table>"
    console.log("filteredImageHtml", filteredImageHtmlPre+  filteredImageHtml + " </tbody> </table>")
     document.getElementById("AIFImageSliderM&T").innerHTML = fullInnerHTML;
      let data = <table className="table table-bordered">
         <thead>
        <tr>
          <th scope="col">S.No</th>
          <th scope="col">Implement Subsidy ID</th>
          <th scope="col">Implement Subsidy Name</th>
        </tr>
      </thead>
      <tbody>
        {result.data.data
          ? result.data.data.map((item, index) => {
              return (
                <tr key={index}>
                  <th scope="row">{index}</th>
                  <td>{item.seasonName}</td>
                  <td>{item.cropName}</td>
                
                </tr>
              );
            })
          : ""}
      </tbody>
    </table>

    console.log("data", data)

    }
    setStatesData(result.data.dataContent);
  };
  fetchMandTdata();


console.log("mandt", value)
}

    function handleSubDistrict(value, DDValue) {

        setDistrictValue(value);

        if (value === "NA") {
            return;
        }
        if (value != null) {
            var raw = JSON.stringify({
                // subdistrictcode: value,
                districtcode: value,
            });
        } else {
            var raw = JSON.stringify({
                // subdistrictcode: value,
                districtcode: districtValue,
            });
        }

        // setSubDistrictValue(value);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/subdistrict`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => setSubDistrictData(JSON.parse(result).dataContent))
            .catch((error) => console.log("error", error));
    }
    function handleBlock(value) {
        setSubDistrictValue(value);
        if (value === "NA") {
            return;
        }

        var raw = JSON.stringify({
            subdistrictcode: value,
            districtcode: districtValue,
        });

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/block`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => setBlockData(JSON.parse(result).dataContent))
            .catch((error) => console.log("error", error));
    }

    function handleVillage(value) {
        // setSubDistrictValue(value);

        if (value === "NA") {
            return;
        }

        var raw = JSON.stringify({
            blockcode: blockValue,
        });

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/village`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => setVillageData(JSON.parse(result).dataContent))
            .catch((error) => console.log("error", error));
    }


    // const indiaExtent = [9631726, 2443000, 10606495.879694397, 2935000];
    const indiaExtent = [6968477.263451013, 717270.1119974239, 11000000, 4555010.368617255]
    const mapRef = useRef(null);
    const satelliteLayer = new TileLayer({
        source: new XYZ({
            url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
        }),

    })
    const terrainLayer = new TileLayer({
        source: new XYZ({
            url: 'https://mt1.google.com/vt/terrain=t&x={x}&y={y}&z={z}',
        }),
    })

    const getMarkerBindOnMap = (coordinatesArray, label) => {
    }

      function RKVYInfoFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/RKVY/RKVY/FetchRKVYDetailIdWise`,
        {
          "Id": String(value)
        }
      );
      resolve(y);
      reject(y)
    });
  } 

  function SHCFarmerDetails(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/CommonAPI/SHCFarmerDetailsbyFarmerId`,
        {
          "farmerId": String(value)
        }
      );
      resolve(y);
      reject(y)
    });
  }
  function seedDeails(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/SeedHub/FetchSeedHubDetailIdWise`,
        {
          "id": String(value)
        }
      );
      resolve(y);
      reject(y)
    });
  }

     function RKVYFetchDataStateWise(stateCode) {

    console.log("value@@@1111", stateCode)
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/RKVY/RKVY/FetchLatLongRKVY`,
        {  

    
          "StateId":  String(stateCode),
          "DistrictId": districtValue === "NA" || districtValue === "" ? "" : districtValue,
         
         
        }
      );
      resolve(y);
    });
  }

    // API Call

    function NMEO_3F_Perspective() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Reverse/CommonAPI/GetFarmerDataByStateCode`,
                {
                    stateCode:  stateValue === "0" ? "0" : stateValue,
                    DistrictCode: districtValue === "0"? "0" : districtValue ,
                    TehsilBlockCode: '0',
                    VillageCode: '0',
                    perspective: '1'
                }
            );
            resolve(y);
        });
    }
    function NMEO_OP_Details() {
        const validStateCode = !stateValue || stateValue === "" || stateValue === "0" ? "0" : stateValue;
        
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/NMEO_OP/getNMEOFarmerDetailsList`,
                {
                     "schemeCode": 14,
                      "stateCode":  validStateCode,
                      "orgTypeCode": 1,
                      "lngA_FarmerCode": 0,
                      "str_MobileNo": "",
                      "int_State_Code": parseInt(validStateCode),
                      "int_District_Code": 0,
                      "int_SubDistrict_Code": 0,
                      "int_Block_Code": 0,
                      "int_VillageCode": 0,
                      "lng_SurveyUserCode": 0
                }
            );
            resolve(y);
        });
    }
    function NMEO_OS_Details() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/NMEOS/getNMEOSFarmerDetailsAll`,
                {
                     "schemeCode": 5,
                      "stateCode":  stateValue === "0" ? "0" : stateValue,
                      "orgTypeCode": 1,
                      "lngA_FarmerCode": 0,
                      "str_MobileNo": "",
                      "int_State_Code": parseInt(stateValue === "0" ? "0" : stateValue),
                      "int_District_Code": 0,
                      "int_SubDistrict_Code": 0,
                      "int_Block_Code": 0,
                      "int_VillageCode": 0,
                      "lng_SurveyUserCode": 0
                }
            );
            resolve(y);
        });
    }

    function RKVY_NEW_Details() {
        
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/RKVY/RKVYProject/RKVYProjectExtList`,
                {
                    "schemeCode": 15,
                    "stateCode":  stateValue === "0" ? "0" : stateValue,
                    
                }
            );
            resolve(y);
        });
    }
     function Patanjali_data() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `https://km.amnex.co.in/appdevapi/api/Reverse/Patanjali/FetchKMLFilesbyStateCode`,
                {
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    
                }
            );
            resolve(y);
        });
    }
   function ACABCFetchData(filterValue) {
  return new Promise((resolve, reject) => {
    axios.post(
      `${process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE
      }/api/${filterValue === "1" ? "Reverse/CommonAPI/PostInstitutionACABC" : "reverse/CommonAPI/PostACABC"}`,
      {
        state: stateValue === "NA" ? "" : stateValue,
        district: districtValue === "NA" || filterValue === "1" ? "" : districtValue,
        village: "",
      }
    ).then(resolve).catch(reject);
  });
}
 

    function GTDataDetails() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/GT/GetSurveyDetailsOnly`,
                {
                    state: stateValue === "NA" ? "" : stateValue,
                    district: districtValue === "NA" || acabcFilter === "1" ? "" : districtValue,
                    village: "",
                    UperLevelUserCode: '1',
                    PageNumber:'1'

                }
            );
            resolve(y);
        });
    }

    function AIFFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/reverse/CommonAPI/PostAIFData2`,
                {
                    SchemeCode: "Agri Infra Fund",
                    state: stateValue === "NA" ? "" : stateValue,
                    district: districtValue === "NA" ? "" : districtValue,
                    village: villageValue === "NA" ? "" : villageValue,

                }
            );
            resolve(y);
        });
    }


    function NMEO_3F_ConversionDetails() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/reverse/CommonAPI/GetPalmOilConversionDetails?Type=5"}`,
                {
                }
            );
            resolve(y);
        });
    }

    function KECultivationFetchDetails() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/reverse/CommonAPI/PostKECultivationFarmerDetails`,
                {

                    "schemeCode": 3,
                    // "orgTypeCode": 1,
                    // "SurveyUserCode" : 0,
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue

                }
            );
            resolve(y);
        });
    }

    function AgroforestryFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Nature/FarmerDetails/getProjectDetailsList`,
                {

                    "schemeCode": 3,
                    // "orgTypeCode": 1,
                    // "SurveyUserCode" : 0,
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue

                }
            );
            resolve(y);
        });
    }

    function AMIFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `https://krishimapper.dac.gov.in/appdevapi/api/AMI/AMI/getAMIProjectDetailLists`,
                {
                    SchemeCode: "0",
                    state: stateValue === "NA" ? "" : stateValue,
                    district: districtValue === "NA" ? "" : districtValue,
                    village: villageValue === "NA" ? "" : villageValue,

                }
            );
            resolve(y);
        });
    }

    function M_And_T_FetchData(apiType) {
      //alert(apiType);
      return axios.post(
        `${process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/CommonAPI/${
          apiType === "1"
            ? "Get_FMDBT_CHCPolygonHistoryDetails_GIS_Dashboard"
            : "Get_FMDBT_CHCPolygonDetails_GIS_Dashboard"
        }`,
        {
          stateCode: stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          districtCode: districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          subDistrictCode: subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          blockCode: blockValue === "NA" || blockValue === "" ? 0 : blockValue,
          revenueVillageCode: villageValue === "NA" || villageValue === "" ? 0 : villageValue
        }
      );
    }


    function NBHMAFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Nature/FarmerDetails/getProjectDetailsList`,
                {

                    "schemeCode": 7,
                    "orgTypeCode": 1,
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue

                }
            );
            resolve(y);
        });
    }

    function NBHMBFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Nature/FarmerDetails/getProjectDetailsList`,
                {

                    "schemeCode": 7,
                    "orgTypeCode": 2,
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue

                }
            );
            resolve(y);
        });
    }

    function NBHMCFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Nature/FarmerDetails/getProjectDetailsList`,
                {

                    "schemeCode": 7,
                    "orgTypeCode": 3,
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue

                }
            );
            resolve(y);
        });
    }

    function NBHMDFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Nature/FarmerDetails/getFarmerDetailsList`,
                {

                    "schemeCode": 7,
                    "orgTypeCode": 4,
                    "SurveyUserCode": 0,
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue

                }
            );
            resolve(y);
        });
    }

    function NFSMFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/NFSM/cropDemo/getCropDemoDetailsList`,
                {
                    finYear: "",
                    cropGroupCode: "",
                    cropCode: "",
                    seasonName: "",
                    stateCode: stateValue === "NA" ? "" : stateValue,
                    districtCode: districtValue === "NA" ? "" : districtValue,
                    blockCode: blockValue === "NA" ? "" : blockValue,
                    villageCode: villageValue === "NA" ? "" : villageValue,
                    seasonCode: 0,
                }
            );
            resolve(y);
        });
    }

    function NHBFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/reverse/CommonAPI/PostNHBData`,
                {
                    state: stateValue === "NA" ? "" : stateValue,
                    district: districtValue === "NA" ? "" : districtValue,
                    village: villageValue === "NA" ? "" : villageValue,

                }
            );
            resolve(y);
        });
    }

    function PDMCFetchData() {
        //alert('pdmc')
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Nature/FarmerDetails/getFarmerDetailsList`,
                {

                    "schemeCode": 1,
                    "orgTypeCode": 1,
                    "SurveyUserCode": 0,
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue,

                }
            );
            resolve(y);
        });
    }

    function RADFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Nature/FarmerDetails/getFarmerDetailsList`,
                {

                    "schemeCode": 2,
                    "orgTypeCode": 1,
                    "SurveyUserCode": 0,
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,

                }
            );
            resolve(y);
        });
    }

    function STLLabFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/SHC/STLDetails/getSTLDetailsList`,
                {
                    farmerName: "",
                    email: "",
                    phone: "",
                    aadharnumber: "",
                    stateCode: stateValue === "NA" ? "" : stateValue,
                    districtCode: districtValue === "NA" ? "" : districtValue,
                    villageCode: villageValue === "NA" ? "" : villageValue,
                }
            );
            resolve(y);
            reject(y)
        });
    }

    function SHCFarmerFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Reverse/CommonAPI/SHCFarmerLatLong`,
                {
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue,
                    // "farmerId": ""

                }
            );
            resolve(y);

        });
    }

    function CropicFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/CropSurvey/getGISCropSurveyLatLongList`,


                {

                    "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? "0" : districtValue,
                    "level4Code": "0",
                    "villageCode": "0",
                    "orgTypeCode": "",
                    "filterYear": "",
                    "userTypeCode": 0,
                    "filterSeasonCode": 0
                }
            );
            resolve(y);
            reject(y)
        });
    }


    function RKVYFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/RKVY/RKVY/FetchStateWiseRKVYCount`,
                {


                    "stateId": stateValue === "NA" || stateValue === "" ? "" : stateValue,
                    "districtId": districtValue === "NA" || districtValue === "" ? "" : districtValue,


                }
            );
            resolve(y);
        });
    }
    function NaturalFarmingFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Reverse/NaturalFarming/PostNaturalFarmingData`,
                {
                    "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
                    "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue

                }
            );
            resolve(y);
        });
    }

    function MIDHFetchData(value) {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/MIDH/MIDHFarmerDetails/GetMidhFarmerDetailsAsync`,
                {
                    "schemeCode": "8",
                    "orgTypeCode": 0,
                    "SurveyUserCode": "0",
                    "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? "0" : districtValue,
                    "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "0" : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? "0" : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? "0" : villageValue


                }
            );
            resolve(y);
            reject(y)
        });
    }

    function MOVCDFetchData(value) {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Nature/FarmerDetails/getFarmerDetailsListNew`,
                {
                    "schemeCode": "9",
                    "orgTypeCode": 0,
                    "SurveyUserCode": "0",
                    "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? "0" : districtValue,
                    "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "0" : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? "0" : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? "0" : villageValue
                }
            );
            resolve(y);
            reject(y)
        });
    }

    function NPSSFetchData(value) {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/NPSS_ETL/NPSS_ETL/NPSS_ETLData`,
                {
                    "stateCode": stateValue === "NA" || stateValue === "" ? "" : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? "" : districtValue,
                    "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "" : subDistrictValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? "" : villageValue
                }
            );
            resolve(y);
            reject(y)
        });
    }

    function CottonFetchData(value) {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Cotton/FetchCottonDetail`,
                {
                    "stateId": stateValue === "NA" || stateValue === "" ? "" : stateValue,
                    "districtId": districtValue === "NA" || districtValue === "" ? "" : districtValue,
                    "blockId": subDistrictValue === "NA" || subDistrictValue === "" ? "" : subDistrictValue,
                    "villageId": villageValue === "NA" || villageValue === "" ? "" : villageValue
                }
            );
            resolve(y);
            reject(y)
        });
    }
    function SeedHubFetchData() {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/SeedHub/FetchSeedHubLatLongDetails`,
                {
                    "stateId": stateValue === "NA" || stateValue === "" ? "" : stateValue,
                    "districtId": districtValue === "NA" || districtValue === "" ? "" : districtValue,
                    "blockId": blockValue === "NA" || blockValue === "" ? "" : blockValue,
                    "villageId": villageValue === "NA" || villageValue === "" ? "" : villageValue,

                }
            );
            resolve(y);
        });
    }

    function FetchSeedHubLatLongDetails(value) {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/SeedHub/FetchSeedHubLatLongDetails`,
                {


                    "stateId": String(value.stateCode),
                    "districtId": districtValue === "NA" || districtValue === "" ? "" : districtValue,
                    "blockId": blockValue === "NA" || blockValue === "" ? "" : blockValue,
                    "villageId": villageValue === "NA" || villageValue === "" ? "" : villageValue,

                }
            );
            resolve(y);
        });
    }

    function FetchSeedHubDetailIdWise(value) {

        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/SeedHub/FetchSeedHubDetailIdWise`,
                {


                    "Id": String(value)


                }
            );
            resolve(y);
        });
    }

    function CDBFetchData(value) {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/CDB/CDB/GetCDBFarmerDetailsAsync`,
                {
                    "schemeCode": "10",
                    "orgTypeCode": 0,
                    "SurveyUserCode": "0",
                    "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? "0" : districtValue,
                    "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "0" : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? "0" : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? "0" : villageValue
                }
            );
            resolve(y);
            reject(y)
        });
    }

    function DASDFetchData(value) {
        return new Promise((resolve, reject) => {
            const y = axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/MIDH/MIDHFarmerDetails/GetDasdFarmerDetailsAsync`,
                {
                    "schemeCode": "11",
                    "orgTypeCode": 0,
                    "SurveyUserCode": "0",
                    "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
                    "districtCode": districtValue === "NA" || districtValue === "" ? "0" : districtValue,
                    "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "0" : subDistrictValue,
                    "blockCode": blockValue === "NA" || blockValue === "" ? "0" : blockValue,
                    "villageCode": villageValue === "NA" || villageValue === "" ? "0" : villageValue
                }
            );
            resolve(y);
            reject(y)
        });
    }

    //End API Call


    // Handle After Api Call
    const handleNMEOComapny = async (event) => {
        if(event.target.value === "27"){
            alert("no data found");
            handleClear();
            return false;
        }

        let value = [];
        setSelected([]);
        const selectedValue = event.target.value;
       
        setSelectedCompany(selectedValue);
          
       // setSelected((prevSelected) => prevSelected.slice(1));
        if(selectedValue === '28'){
           
            setSelected([{ label: "NMEO-Palm oil", value: "28" }]);
        }
       else if(selectedValue === '24'){
            setSelected([{ label: "NMEO-Palm Oil", value: "24" }]);
            const newSelection = { label: "NMEO-Palm Oil", value: "24" };
            selected.push(newSelection);
        }else if(selectedValue === '25'){
        setSelected([{ label: "NMEO-Palm oil", value: "25" }]);
        const newSelection = { label: "NMEO-Palm Oil", value: "25" };
         if (!selected.some((item) => item.value === newSelection.value)) {
            selected.push(newSelection);
        }


        console.log(selectedValue+'selectedValue');
   
    }

 const handleAddDataKECultivationtest = async () => {
         let value = [];
         selected.map((item) => {
            value.push(item.value);
        });

        if (value.includes("25")) {
            setLoader(true);

            try {
                const resultNMEO_3F = await KECultivationFetchDetails();
                if (resultNMEO_3F.data.data.length > 0) {
                    const newObject = {
                        responseArray: resultNMEO_3F.data.data,
                        markerStyle: BlueMarker,
                        selectedValue: '25',
                        schemename: 'Nmeo333'
                    };

                    setDatasets((prevDatasets) => {
                        // Add the new object to the existing datasets array
                        const updatedDatasets = [...prevDatasets, newObject];
                     
                        return updatedDatasets;
                    });
                }

                setAPISucess(true);
            } catch (error) {
                console.error("Error fetching data:", error);
                setAPISucess(false);
            } finally {
                setLoader(false);
            }
        } else {
            setAPISucess(false);
        }
      }
    };

  
    
    const handleAddDataPatanjali = async () => {
        let value = [];
        
        selected.map((item) => {

            value.push(item.value);
        });


        if (value.includes("28")) {
            setLoader(true);

            const resultNMEO_3F = await Patanjali_data();

             if (resultNMEO_3F.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "NMEO (Patanjali)"]);
               setIsModalOpen(true);
               setLoader(false);
            }

           
            if (resultNMEO_3F.data.recordCount != 0) {

                //alert(resultNMEO_3F.data.data[0].fileName)
                parseKML(resultNMEO_3F.data.data[0].fileName);

                setLoader(false)
            }

            setAPISucess(true)
        }
        else {
            //  setDatasets([]);
            setAPISucess(false);
        }

    }

    const handleAddDataRKVYDeatils = async () => {
       
        let value = [];
        
        selected.map((item) => {

            value.push(item.value);
        });



        if (value.includes("30")) {
            setLoader(true);

            const resultRKVY_New = await RKVY_NEW_Details();


                console.log(resultRKVY_New.data.length)
                console.log(resultRKVY_New.data.recordCount,"recordCount")
             if (resultRKVY_New.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "RKVY"]);
               setIsModalOpen(true);
               setLoader(false);
            }

           
            if (resultRKVY_New.data.recordCount > 0) {
               
                console.log('resultRKVY_New.data',resultRKVY_New.data.dataContent)
                const newObject = {
                    responseArray: resultRKVY_New.data.dataContent,
                    selectedValue: '30',
                    markerStyle: BlueMarker,
                    schemename: 'RKVY'
                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
               
                setLoader(false)
            }

            setAPISucess(true)
        }
        else {
            //  setDatasets([]);
            setAPISucess(false);
        }


    };

    const handleAddDataNMEOOP = async () => {
  const values = selected.map((item) => item.value);

  // Only proceed if "29" is selected
  if (values.includes("29")) {
    setLoader(true);

    try {
      /** -------------------- 1. NMEO_OP_Details -------------------- **/
      const resultNMEO_OP = await NMEO_OP_Details();
      
      if (resultNMEO_OP.data.recordCount === 0) {
        setMissingSchemes((prev) => [...prev, "National Mission on Edible Oils (NMEO)-OP"]);
        setIsModalOpen(true);
        // Even if no data, add empty dataset for analytics
        const newObject = {
          responseArray: [],
          selectedValue: "29",
          markerStyle: LightPurpleMarker,
          schemename: "NMEO-OP",
        };
        setDatasets((prev) => [...prev, newObject]);
      } else {
       const filteredData = resultNMEO_OP.data.dataContent.filter(
          item => Array.isArray(item.farmerCropSurveyPolygonList) && item.farmerCropSurveyPolygonList.length > 0
        );
       
       // Always add to datasets for analytics, even if no polygon data
       const dataToAdd = filteredData.length > 0 ? filteredData : resultNMEO_OP.data.dataContent;
       
       const newObject = {
        responseArray: dataToAdd,
        selectedValue: "29",
        markerStyle: LightPurpleMarker,
        schemename: "NMEO-OP",
      };
      setDatasets((prev) => [...prev, newObject]);

      }

      /** -------------------- 2. KECultivationFetchDetails -------------------- **/
      const resultKECultivation = await KECultivationFetchDetails();
      if (resultKECultivation.data.recordCount === 0) {
        setMissingSchemes((prev) => [...prev, "NMEO (KE Cultivation)"]);
        setIsModalOpen(true);
      } else if (resultKECultivation.data.data.length > 0) {
        const newObject = {
          responseArray: resultKECultivation.data.data,
          selectedValue: "25",
          markerStyle: LightPinkMarker,
          schemename: "NMEO (KE Cultivation)",
        };
        setDatasets((prev) => [...prev, newObject]);
      }

      /** -------------------- 3. NMEO_3F_Perspective -------------------- **/
      const resultPalmOil = await NMEO_3F_Perspective();
      if (resultPalmOil.data.recordCount === 0) {
        setMissingSchemes((prev) => [...prev, "NMEO (Palm Oil)"]);
        setIsModalOpen(true);
      } else if (resultPalmOil.data.dataContent.length > 0) {
        const newObject = {
          responseArray: resultPalmOil.data.dataContent,
          selectedValue: "24",
          markerStyle: LitegreenMarker,
          schemename: "NMEO (Palm Oil)",
        };
        setDatasets((prev) => [...prev, newObject]);
      }

      /** -------------------- 4. Patanjali_data -------------------- **/
      const resultPatanjali = await Patanjali_data();
      if (resultPatanjali.data.recordCount === 0) {
        setMissingSchemes((prev) => [...prev, "NMEO (Patanjali)"]);
        setIsModalOpen(true);
      } else if (resultPatanjali.data.data.length > 0) {
        parseKML(resultPatanjali.data.data[0].fileName); // Assumes this modifies the map directly
      }

      setAPISucess(true);
    } catch (error) {
      console.error("Error in NMEO combined fetch:", error);
      // Even on error, add empty dataset for analytics
      const newObject = {
        responseArray: [],
        selectedValue: "29",
        markerStyle: LightPurpleMarker,
        schemename: "NMEO-OP",
      };
      setDatasets((prev) => [...prev, newObject]);
      setAPISucess(false);
    } finally {
      setLoader(false);
    }
  } else {
    setAPISucess(false);
  }
};


    const handleAddDataNMEOOPs = async () => {
        let value = [];
        selected.map((item) => {
            value.push(item.value);
        });
        if (value.includes("29")) {
            setLoader(true);
            const resultNMEO_OP = await NMEO_OP_Details();
                console.log(resultNMEO_OP.data.length)
                console.log(resultNMEO_OP.data.recordCount,"recordCount")
             if (resultNMEO_OP.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "NMEO (3F)"]);
               setIsModalOpen(true);
               setLoader(false);
            }
            if (resultNMEO_OP.data.recordCount > 0) {
                
                console.log('resultNMEO_OP.data',resultNMEO_OP.data.dataContent)
                const newObject = {
                    responseArray: resultNMEO_OP.data.dataContent,
                    selectedValue: '29',
                    markerStyle: DarkGrayMarker,
                    schemename: 'Nmeo333'
                };
                setDatasets(prevDatasets => [...prevDatasets, newObject]);
                setLoader(false)
            }
            setAPISucess(true)
        }
        else {
            setAPISucess(false);
        }
    }; 
    const handleAddDataNMEOOS = async () => {
        let value = [];
        selected.map((item) => {
            value.push(item.value);
        });
        if (value.includes("31")) {
            setLoader(true);
            const resultNMEO_OS = await NMEO_OS_Details();
                console.log(resultNMEO_OS.data.length)
                console.log(resultNMEO_OS.data.recordCount,"recordCount")
             if (resultNMEO_OS.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "NMEO OS"]);
               setIsModalOpen(true);
               setLoader(false);
            }
            if (resultNMEO_OS.data.recordCount > 0) {
                
                console.log('resultNMEO_OS.data',resultNMEO_OS.data.dataContent)
                const newObject = {
                    responseArray: resultNMEO_OS.data.dataContent,
                    selectedValue: '29',
                    markerStyle: BlueMarker,
                    schemename: 'Nmeo333'
                };
                setDatasets(prevDatasets => [...prevDatasets, newObject]);
                setLoader(false)
            }
            setAPISucess(true)
        }
        else {
            setAPISucess(false);
        }
    };
    
    const handleAddDataPalmOil = async () => {
       
        let value = [];
        
        selected.map((item) => {

            value.push(item.value);
        });


        if (value.includes("24")) {
            setLoader(true);
            const resultNMEO_3F = await NMEO_3F_Perspective();
            
             if (resultNMEO_3F.data.recordCount === 0) {
               
               setMissingSchemes(prev => [...prev, "NMEO (3F)"]);
               setIsModalOpen(true);
               setLoader(false);
            }
           // setMissingSchemes(prev => [...prev, "NMEO (3F)"]);
          
            if (resultNMEO_3F.data.dataContent.length > 0) {
                const newObject = {
                    responseArray: resultNMEO_3F.data.dataContent,
                    selectedValue: '24',
                    markerStyle: BlueMarker,
                    schemename: 'Nmeo333'
                };
                
                
                setDatasets(prevDatasets => [...prevDatasets, newObject]);
               
                setLoader(false)
            }
            
            setAPISucess(true)
        }
        else {
            //  setDatasets([]);
            setAPISucess(false);
        }


    };  

    const handleAddDataGT = async () => {

            let value = []; 
        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("26")) {
            setLoader(true);

            const resultGTData = await GTDataDetails();
             if (resultGTData.data.recordCount === 0) {
             
               setMissingSchemes(prev => [...prev, "GT"]); 

               setIsModalOpen(true);
               setLoader(false);
            }

            if (resultGTData.data.dataContent.length > 0) {
                const newObject = {
                    responseArray: resultGTData.data.dataContent,
                    selectedValue: '26',
                    markerStyle: PurpleMarker,
                    schemename: 'GT'
                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
                

            }
            setAPISucess(true)
        } else {
            //setDatasets([]);
            setAPISucess(false);
        }
    }

    function bhuvanDisplay() {
     sessionStorage.setItem('selectedValue', JSON.stringify(selected));const valueMap = {
        "10": 1,
        "11": 2
        // Add more mappings as needed
     };

    
    const transformed = selected.map(item => valueMap[item.value]);

   
    sessionStorage.setItem('selectedValue', JSON.stringify(transformed));


    }

    const handleAddDataACABC = async () => {

        let value = []; 
        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("24")) {
            setLoader(true);

            const resultACABCNMEO = await NMEO_3F_ConversionDetails();
             if (resultACABCNMEO.data.recordCount === 0) {
             
               setMissingSchemes(prev => [...prev, "NMEO-Palm Oil"]); 

               setIsModalOpen(true);
               setLoader(false);
            }

            if (resultACABCNMEO.data.dataContent.length > 0) {
                const newObject = {
                    responseArray: resultACABCNMEO.data.dataContent,
                    selectedValue: '24',
                    markerStyle: PurpleMarker,
                    schemename: 'Nmeo222'
                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);


            }
            setAPISucess(true)
        } else {
            //setDatasets([]);
            setAPISucess(false);
        }

    };

   const handleAddDataACABCNew = async () => {
  let value = [];
  selected.forEach((item) => value.push(item.value));

  if (value.includes("1")) {
    setLoader(true);
    setACABCData([]);
    setACABCPolygonData([]);

    let allResults = [];
    let totalCount = 0;
    //alert(acabcFilter);
    // If schemeDropDown is "1", fetch both APIs
    if (acabcFilter === "1") {
      // First API: Nodal Training Institute
      const resultNTI = await ACABCFetchData("1");
      if (resultNTI?.data?.dataContent?.length > 0) {
        allResults = [...allResults, ...resultNTI.data.dataContent];
        setDatasets(prev => [
          ...prev,
          {
            responseArray: resultNTI.data.dataContent,
            selectedValue: "1",
            markerStyle: GreenMarker,
            schemename: "ACABC (Nodal Training Institute)"
          }
        ]);
      } else {
        setMissingSchemes(prev => [...prev, "ACABC (Nodal Training Institute)"]);
        setIsModalOpen(true);
      }

      // Second API: Agriventure
      // const resultAGV = await ACABCFetchData("2");
      // if (resultAGV?.data?.dataContent?.length > 0) {
      //   allResults = [...allResults, ...resultAGV.data.dataContent];
      //   setDatasets(prev => [
      //     ...prev,
      //     {
      //       responseArray: resultAGV.data.dataContent,
      //       selectedValue: "1",
      //       markerStyle: GreenMarker,
      //       schemename: "ACABC (Agriventure)"
      //     }
      //   ]);
      // } else {
      //   setMissingSchemes(prev => [...prev, "ACABC (Agriventure)"]);
      //   setIsModalOpen(true);
      // }

    //  totalCount = (resultNTI?.data?.recordCount || 0) + (resultAGV?.data?.recordCount || 0);
    } else {
      // Fallback to single API based on acabcFilter
      if (acabcFilter === "") setAcabcFilter("2");

      const resultACABC = await ACABCFetchData(acabcFilter);

      if (resultACABC?.data?.dataContent?.length > 0) {
        allResults = [...resultACABC.data.dataContent];
        const schemeLabel = acabcFilter === "1" ? "ACABC (Nodal Training Institute)" : "ACABC (Agriventure)";
        setDatasets(prev => [
          ...prev,
          {
            responseArray: resultACABC.data.dataContent,
            selectedValue: "1",
            markerStyle: GreenMarker,
            schemename: schemeLabel
          }
        ]);
      } else {
        setMissingSchemes(prev => [
          ...prev,
          "ACABC " + (acabcFilter === "1" ? "(Nodal Training Institute)" : "(Agriventure)")
        ]);
        setIsModalOpen(true);
      }

      totalCount = resultACABC?.data?.recordCount || 0;
    }

    // Set full data and CSV stats
    setACABCData(allResults);

    let items = [...csvArrayData];
    let item = { ...items[0] };
    item.TotalCount = totalCount;
    items[0] = item;
    setCsvArrayData(items);

    setAPISucess(true);
    setLoader(false);
  }
};


    const handleAddDataKECultivation = async () => {
        
         let value = [];
         selected.map((item) => {
            value.push(item.value);
        });

        if (value.includes("25")) {
            setLoader(true);

            try {
                const resultNMEO_3F = await KECultivationFetchDetails();


              if (resultNMEO_3F.data.recordCount === 0) {
                setMissingSchemes(prev => [...prev, "NMEO (KE Cultivation)"]); 
               
                 setIsModalOpen(true);
                 setLoader(false);

              }
               

                if (resultNMEO_3F.data.data.length > 0) {
                    const newObject = {
                        responseArray: resultNMEO_3F.data.data,
                        selectedValue: '25',
                        markerStyle: BlueMarker,
                        schemename: 'Nmeo333'
                    };

                    setDatasets((prevDatasets) => {
                        // Add the new object to the existing datasets array
                        const updatedDatasets = [...prevDatasets, newObject];
                        
                        return updatedDatasets;
                    });
                }

                setAPISucess(true);
            } catch (error) {
                console.error("Error fetching data:", error);
                setAPISucess(false);
            } finally {
                setLoader(false);
            }
        } else {
            setAPISucess(false);
        }
      
    };
    const handleAddDataAIF = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("3")) {
            setLoader(true)
            setAIFData([]);
            const resultAIF = await AIFFetchData();

            //setAIFData(resultAIF.data);

            if (resultAIF.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "AIF"]); 
               
               setIsModalOpen(true);
               setLoader(false);

            } 


            if (resultAIF.data.dataContent.length > 0) {

                setLoader(false)
                const newObject = {
                    responseArray: resultAIF.data.dataContent,
                    selectedValue: '3',
                    markerStyle: YellowMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setAIFData([]);
        }
    };

    const handleAddDataAgroforestry = async () => {
        let value = [];
        selected.map((item) => {
            value.push(item.value);
        });

        if (value.includes("2")) {
            setLoader(true)
            setAgroforestryData([]);

            const resultAgroforestry = await AgroforestryFetchData();

            setAgroforestryData(resultAgroforestry.data.dataContent);
            //  document.getElementById("2").innerHTML = resultAgroforestry.data.recordCount;

            if (resultAgroforestry.data.recordCount === 0) {
               
               setMissingSchemes(prev => [...prev, "AgroForestry"]); 
               
               setIsModalOpen(true);
               setLoader(false);

            } 

            if (resultAgroforestry.data.dataContent.length > 0) {

                setLoader(false)
                const newObject = {
                    responseArray: resultAgroforestry.data.dataContent,
                    selectedValue: '2',
                    markerStyle: LightPinkMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            };
        }

    };

    const handleAddDataAMI = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("40")) {
            setLoader(true)
            setAMIData([]);
            const resultAMI = await AMIFetchData();

            setAMIData(resultAMI.data.dataContent);
            // document.getElementById("4").innerHTML = resultAMI.data.recordCount;

            if (resultAMI.data.recordCount === 0) {

               setMissingSchemes(prev => [...prev, "Agriculture Marketing-AMI"]); 
               
              
               setIsModalOpen(true);
               setLoader(false);

            /*   setTimeout(() => {
                    setIsModalOpen(false);
                }, 3000);
*/
            } 

            if (resultAMI.data.dataContent.length > 0) {
                setLoader(false)
                const newObject = {
                    responseArray: resultAMI.data.dataContent,
                    selectedValue: '4',
                    markerStyle: PinkMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setAMIData([]);
        }
    };

    const handleShowOneScheme = (schemeCode, schemeName) => {

        /*const newItem = { value: "10", label: "PDMC" };
        setSelected([]);
        handleClear();

        // Use setTimeout to wait for previous state update to finish
        setTimeout(() => {
            setSelected([newItem]);
            handleAddMarker(); // Call after selected is updated
        }, 0);

        alert(`${schemeCode} -- ${schemeName}`);*/
    };

    const handleShowTopStates = (dataset) => {
  const responseArray = dataset.responseArray || [];
  
  // Special handling for NBHM data
  if (dataset.selectedValue === "6") {
    // Group by scheme type and state
    const schemeTypes = {
      "1": "Honey Processing Unit",
      "2": "Honey Testing Unit", 
      "3": "Honey CHC",
      "4": "Beeflora Plantation"
    };
    
    const groupedData = {};
    
    responseArray.forEach(item => {
      const typeCode = item.orgTypeCode || dataset.schemename.split('-')[1]?.trim();
      const state = item.stateName || "Unknown";
      
      if (!groupedData[typeCode]) {
        groupedData[typeCode] = {};
      }
      
      groupedData[typeCode][state] = (groupedData[typeCode][state] || 0) + 1;
    });
    
    // Format for display
    const result = [];
    Object.entries(groupedData).forEach(([typeCode, stateCounts]) => {
      const topStates = Object.entries(stateCounts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5);
        
      result.push({
        schemeType: schemeTypes[typeCode] || `NBHM Type ${typeCode}`,
        topStates
      });
    });
    
    setTopStates(result);
    setIsTopStatesModalOpen(true);
    return;
  }
  
  // Default handling for other schemes
  const stateCounts = {};
  responseArray.forEach(item => {
    const state = item.stateName || item.farmer_State_Name || "Unknown";
    stateCounts[state] = (stateCounts[state] || 0) + 1;
  });
  
  const topStates = Object.entries(stateCounts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);
  
  setTopStates(topStates);
  setIsTopStatesModalOpen(true);
};

   const parseKML = async (file) => {
    try {
        console.log(file);
        // Fetch the KML file from the public folder
        const response = await fetch("/"+file);
        const kmlString = await response.text();

        // Parse KML to XML
        const parser = new DOMParser();
        const dom = parser.parseFromString(kmlString, "text/xml");

        // Convert KML to GeoJSON (using your `kml()` function)
        const geoJSON = kml(dom);

        // Update state with parsed data
        setDatasets(prevDatasets => [
            ...prevDatasets,
            {
                responseArray: geoJSON,
                selectedValue: "28",
                markerStyle: BlueMarker,
                schemename: "Patanjali"
            }
        ]);

        console.log("Parsed KML to GeoJSON:", geoJSON);
    } catch (error) {
        console.error("Error loading KML file:", error);
    }
}
  const handleAddDataMANDT = async () => {
  let value = [];

  selected.forEach((item) => {
    value.push(item.value);
  });

  if (value.includes("5")) {
    setLoader(true);
    setMANDTData([]);
    let results = [];
      
    try {
      if (mandtFilter === "2") {
     const [historyResult] = await Promise.all([
            M_And_T_FetchData(mandtFilter), // history (FMDBT - KM)
            // M_And_T_FetchData("0"), // current (FarmsApp)
          ]);

          const missing = [];

          // History data (FMDBT - KM)
          const historyContent = historyResult?.data?.dataContent || [];
          const historyCount = historyResult?.data?.recordCount || 0;

          if (historyCount > 0) {
            setDatasets((prev) => [
              ...prev,
              {
                responseArray: historyContent,
                selectedValue: "5",
                markerStyle: BlueMarker,
                schemename: "M&T-CHC(Source of Registration FMDBT (KM))",
              },
            ]);
          } else {
            missing.push("M&T-CHC(Source of Registration FMDBT (KM))");
          }

          if (missing.length > 0) {
            setMissingSchemes((prev) => [...prev, ...missing]);
            setIsModalOpen(true);
          }

      } else {
     
        const result = await M_And_T_FetchData(mandtFilter);
        const content = result.data?.dataContent || [];
        const recordCount = result.data?.recordCount || 0;

        if (recordCount > 0) {
          setDatasets((prev) => [
            ...prev,
            {
              responseArray: content,
              selectedValue: "5",
              markerStyle: BlueMarker,
            },
          ]);
        } else {
          const missingLabel =
            mandtFilter === "0"
              ? "M&T-CHC(Source of Registration FarmsApp)"
              : "M&T-CHC(Source of Registration FMDBT (KM))";
          setMissingSchemes((prev) => [...prev, missingLabel]);
          setIsModalOpen(true);
        }
      }
    } catch (error) {
      console.error("Error fetching M&T data:", error);
    } finally {
      setLoader(false);
    }

  } else {
    setMANDTData([]);
  }

    };

const handleAddDataNBHM = async () => {
  if (!selected.some(item => item.value === "6")) {
    return; // NBHM not selected
  }

  setLoader(true);
  
  try {
    // Reset NBHM data but keep labels
    setNBHMData(prev => ({
      A: { ...prev.A, data: [] },
      B: { ...prev.B, data: [] },
      C: { ...prev.C, data: [] },
      D: { ...prev.D, data: [] }
    }));

    // If no specific types selected, show all by default
    const selectedTypes = selectedNBHM.length > 0 ? 
      selectedNBHM.map(item => item.value) : 
      ["1", "2", "3", "4"];

    const apiCalls = [];
    
    if (selectedTypes.includes("1")) {
      apiCalls.push(NBHMAFetchData().then(res => ({ type: 'A', data: res.data })));
    }
    if (selectedTypes.includes("2")) {
      apiCalls.push(NBHMBFetchData().then(res => ({ type: 'B', data: res.data })));
    }
    if (selectedTypes.includes("3")) {
      apiCalls.push(NBHMCFetchData().then(res => ({ type: 'C', data: res.data })));
    }
    if (selectedTypes.includes("4")) {
      apiCalls.push(NBHMDFetchData().then(res => ({ type: 'D', data: res.data })));
    }

    const results = await Promise.all(apiCalls);
    const newDatasets = [];
    let hasMissingData = false;

    results.forEach(result => {
      const type = result.type;
      const response = result.data;
      
      if (response?.dataContent?.length > 0) {
        // Update NBHM data state
        setNBHMData(prev => ({
          ...prev,
          [type]: {
            ...prev[type],
            data: response.dataContent
          }
        }));

        // Add to datasets for map display
        newDatasets.push({
          responseArray: response.dataContent,
          selectedValue: '6',
          markerStyle: NBHMData[type].marker,
          schemename: `NBHM-${type}`,
          recordCount: response.recordCount || response.dataContent.length
        });
      } else {
        hasMissingData = true;
        setMissingSchemes(prev => [...prev, `NBHM-${type}`]);
      }
    });

    if (newDatasets.length > 0) {
      setDatasets(prev => [...prev, ...newDatasets]);
    }

    if (hasMissingData) {
      setIsModalOpen(true);
    }

  } catch (error) {
    console.error("NBHM API Error:", error);
    setMissingSchemes(prev => [...prev, "NBHM (API Error)"]);
    setIsModalOpen(true);
  } finally {
    setLoader(false);
  }
};

    const handleAddDataNFSM = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("7")) {
            setLoader(true)
            setNFSMData([]);
            console.log('innn');


            const resultNFSM = await NFSMFetchData();
             
            console.log("--------------------------",resultNFSM.data.dataContent.length);
            console.log("--------------------------",resultNFSM.data.dataContent);

            setNFSMData(resultNFSM.data.dataContent);

            if (resultNFSM.data.recordCount === 0) {
              setMissingSchemes(prev => [...prev, "NFSM-CFLD"]); 
               setIsModalOpen(true);
               setLoader(false);

            } 

            if (resultNFSM.data.dataContent.length > 0) {
                setLoader(false)
                const newObject = {
                    responseArray: resultNFSM.data.dataContent,
                    selectedValue: '7',
                    markerStyle: DarkPurpleMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setNFSMData([]);

        }
    };

    const handleAddDataNHB = async () => {
        let value = [];


        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("8")) {
            setNHBData([]);

            const resultNHB = await NHBFetchData();

            setNHBData(resultNHB.data.data);
            // document.getElementById("8").innerHTML = resultNHB.data.recordCount;

            if (resultNHB.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "NHB-Inspection"]); 
               
               setIsModalOpen(true);
               setLoader(false);

            } 

            if (resultNHB.data.dataContent.length > 0) {
                const newObject = {
                    responseArray: resultNHB.data.dataContent,
                    selectedValue: '8',
                    markerStyle: DarkPurpleMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            };


        }
    };

    const handleAddDataPDMC = async () => {
        let value = [];
        selected.map((item) => {    
            console.log("item.value",item.value);
            value.push(item.value);
        });

        if (value.includes("10")) {
             console.log('selected[0].value',selected);
            setLoader(true)
            setPDMCData([]);
            const resultPDMC = await PDMCFetchData();
            console.log('resultPDMC.data');
            console.log('p',resultPDMC.data.dataContent.length);
            setPDMCData('ppp',resultPDMC.data.dataContent);
            
            //alert(resultPDMC.data.dataContent.length)

            if (resultPDMC.data.recordCount === 0) {
              setMissingSchemes(prev => [...prev, "PDMC"]); 
               
               setIsModalOpen(true);
               setLoader(false);

            } 


            if (resultPDMC.data.dataContent.length > 0) {
                //alert('in')
                setLoader(false)
                const newObject = {
                    responseArray: resultPDMC.data.dataContent,
                    selectedValue: '10',
                    markerStyle: PinkHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            };

        } else {
            setPDMCData([]);

        }
    };

    const handleAddDataRAD = async () => {
        let value = [];
        selected.map((item) => {
            value.push(item.value);
        });

        if (value.includes("11")) {
            
            setLoader(true)
            setRADData([]);

            const resultRAD = await RADFetchData();
            console.log("resultRAD.data.dataContent.length",resultRAD.data.dataContent.length);
            setRADData(resultRAD.data.dataContent);
            //  document.getElementById("11").innerHTML = resultRAD.data.recordCount;

            if (resultRAD.data.recordCount === 0) {
              setMissingSchemes(prev => [...prev, "RAD"]); 
               setIsModalOpen(true);
               setLoader(false);

            } 

            if (resultRAD.data.dataContent.length > 0) {
               
                setLoader(false)
                const newObject = {
                    responseArray: resultRAD.data.dataContent,
                    selectedValue: '11',
                    markerStyle: GreenHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setRADData([]);
        }
    };

    const handleAddDataSTLLab = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("12")) {
            setLoader(true);
            setSTLLabData([]);

            const resultSTLLab = await STLLabFetchData();
            setSTLLabData(resultSTLLab.data.dataContent);

            if (resultSTLLab.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "Soil Testing Lab"]); 
               setIsModalOpen(true);
               setLoader(false);

            } 

            if (resultSTLLab.data.dataContent.length > 0) {
                setLoader(false);
                const newObject = {
                    responseArray: resultSTLLab.data.dataContent,
                    selectedValue: '12',
                    markerStyle: GreenHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);

            }
        } else {
            setSTLLabData([]);
        }
    };

    const handleAddDataSHCFarmer = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("13")) {
            setLoader(true)
            setSHCFarmerData([]);

            const resultFarmer = await SHCFarmerFetchData();
            setSHCFarmerData(resultFarmer.data.dataContent);

            if (resultFarmer.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "SHC-Farmer"]);
               setIsModalOpen(true);
               setLoader(false);

            } 

            if (resultFarmer.data.dataContent.length > 0) {
                setLoader(false);
                const newObject = {
                    responseArray: resultFarmer.data.dataContent,
                    selectedValue: '13',
                    markerStyle: BlueHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);

            }


        } else {
            setSHCFarmerData([]);

        }

    };
    const handleAddDataCropic = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("14")) {
            setLoader(true);
            setCropicData([]);
            const resultCropic = await CropicFetchData();
            setCropicData(resultCropic.data.dataContent);

            if (resultCropic.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "Cropic"]);
               
               setIsModalOpen(true);
               setLoader(false);

            } 

            if (resultCropic.data.dataContent.length > 0) {
                setLoader(false);
                const newObject = {
                    responseArray: resultCropic.data.dataContent,
                    selectedValue: '14',
                    markerStyle: PurpleHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);


            }

        } else {
            setCropicData([]);
        }
    };

    const handleAddDataRKVY = async () => {
        let value = [];
        selected.map((item) => {
            value.push(item.value);
        });

        if (value.includes("15")) {
            setLoader(true);
            setRKVYData([]);
            const resultRKVY = await RKVYFetchData();

            setRKVYData(resultRKVY.data.dataContent);

            if (resultRKVY.data.recordCount === 0) {
               
                setMissingSchemes(prev => [...prev, "RKVY"]);
               setIsModalOpen(true);
               setLoader(false);

            } 
            if (resultRKVY.data.dataContent.length > 0) {
                setLoader(false);
                const newObject = {
                    responseArray: resultRKVY.data.dataContent,
                    selectedValue: '15',
                    markerStyle: GrayHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setRKVYData([]);
        }
    };

    const handleAddDataNaturalFarming = async () => {
        let value = [];
        selected.map((item) => {
            value.push(item.value);
        });

        if (value.includes("16")) {
            setLoader(true);
            setNaturalFarmingData([]);
            const resultNaturalFarming = await NaturalFarmingFetchData();

            setNaturalFarmingData(resultNaturalFarming.data.dataContent);

            if (resultNaturalFarming.data.recordCount === 0) {
               
                setMissingSchemes(prev => [...prev, "Natural Farming"]);
               setIsModalOpen(true);
               setLoader(false);

            }

            if (resultNaturalFarming.data.dataContent.length > 0) {

                setLoader(false);
                const newObject = {
                    responseArray: resultNaturalFarming.data.dataContent,
                    selectedValue: '16',
                    markerStyle: PurpleHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setNaturalFarmingData([]);

        }
    };

    const handleAddDataMIDH = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("17")) {
            setLoader(true);
            setMIDHData([]);
            const resultMIDH = await MIDHFetchData();

            setMIDHData(resultMIDH.data.dataContent);
            // document.getElementById("17").innerHTML = resultMIDH.data.recordCount;


            if (resultMIDH.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "MIDH"]);
               setIsModalOpen(true);
               setLoader(false);

            }

            if (resultMIDH.data.dataContent.length > 0) {
                setLoader(false);
                const newObject = {
                    responseArray: resultMIDH.data.dataContent,
                    selectedValue: '17',
                    markerStyle: BlueHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }

        } else {
            setMIDHData([]);

        }
    };

    const handleAddDataMOVCD = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("18")) {
            setLoader(true)
            setMOVCDData([]);
            const resultMOVCD = await MOVCDFetchData();

            setMOVCDData(resultMOVCD.data.dataContent);
            // document.getElementById("18").innerHTML = resultMOVCD.data.recordCount;

            if (resultMOVCD.data.recordCount === 0) {
              
               setMissingSchemes(prev => [...prev, "MOVCD"]);
               setIsModalOpen(true);
               setLoader(false);
            }

            if (resultMOVCD.data.dataContent.length > 0) {
                setLoader(false)
                const newObject = {
                    responseArray: resultMOVCD.data.dataContent,
                    selectedValue: '18',
                    markerStyle: GrayHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setMOVCDData([]);

        }
    };

    const handleAddDataNPSS = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("19")) {
            setLoader(true)
            setNPSSData([]);
            const resultNPSS = await NPSSFetchData();

            setNPSSData(resultNPSS.data.dataContent);

            if (resultNPSS.data.recordCount === 0) {
               
                setMissingSchemes(prev => [...prev, "NPSS"]);
               setIsModalOpen(true);
               setLoader(false);
            }

            if (resultNPSS.data.dataContent.length > 0) {
                setLoader(false)
                const newObject = {
                    responseArray: resultNPSS.data.dataContent,
                    selectedValue: '19',
                    markerStyle: MergentaMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setNPSSData([]);

        }
    };

    const handleAddDataCotton = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("20")) {
            setLoader(true)
            setCottonData([]);
            const resultCotton = await CottonFetchData();

            setCottonData(resultCotton.data.dataContent);
            // document.getElementById("20").innerHTML = resultCotton.data.recordCount;

            if (resultCotton.data.recordCount === 0) {
              
                setMissingSchemes(prev => [...prev, "NFSM-HDPS Cotton"]);
               setIsModalOpen(true);
               setLoader(false);
            }
            
            if (resultCotton.data.dataContent.length > 0) {
                setLoader(false)

                const newObject = {
                    responseArray: resultCotton.data.dataContent,
                    selectedValue: '20',
                    markerStyle: LiteBlueMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setCottonData([]);

        }
    };

    const handleAddDataSeedHub = async () => {
        let value = [];
        selected.map((item) => {
            value.push(item.value);
        });

        if (value.includes("21")) {
            setLoader(true);
            setSeedHubData([]);
            const resultSeedHub = await SeedHubFetchData();

            setSeedHubData(resultSeedHub.data.dataContent);
            // document.getElementById("21").innerHTML = resultSeedHub.data.recordCount;

             if (resultSeedHub.data.recordCount === 0) {
               
                setMissingSchemes(prev => [...prev, "Seed Hub"]);
               setIsModalOpen(true);
               setLoader(false);
            }

            if (resultSeedHub.data.dataContent.length > 0) {
                setLoader(false);
                const newObject = {
                    responseArray: resultSeedHub.data.dataContent,
                    selectedValue: '21',
                    markerStyle: SuperDarkGreenMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);

            }
        } else {
            setSeedHubData([]);
        }
    };

    const handleAddDataCDB = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("22")) {
            setLoader(true);
            setCDBData([]);
            const resultCDB = await CDBFetchData();

            setCDBData(resultCDB.data.dataContent);
            // document.getElementById("22").innerHTML = resultCDB.data.recordCount;

             if (resultCDB.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "Cocunut Development Board (CDB)"]);
               setIsModalOpen(true);
               setLoader(false);
            }

            if (resultCDB.data.dataContent.length > 0) {

                setLoader(false);

                const newObject = {
                    responseArray: resultCDB.data.dataContent,
                    selectedValue: '22',
                    markerStyle: SkyBlueMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);
            }
        } else {
            setCDBData([]);


        }
    };

    const handleAddDataDASD = async () => {
        let value = [];

        selected.map((item) => {

            value.push(item.value);
        });

        if (value.includes("23")) {
            setLoader(true);
            setDASDData([]);
            const resultDASD = await DASDFetchData();

            setDASDData(resultDASD.data.dataContent);
            // document.getElementById("23").innerHTML = resultDASD.data.recordCount;
             if (resultDASD.data.recordCount === 0) {
               setMissingSchemes(prev => [...prev, "Directorate of Arecanut and Spices Development (DASD)"]);
               setIsModalOpen(true);
               setLoader(false);
            }


            if (resultDASD.data.dataContent.length > 0) {

                setLoader(false);
                const newObject = {
                    responseArray: resultDASD.data.dataContent,
                    selectedValue: '23',
                    markerStyle: GrayHomeMarker

                };

                setDatasets(prevDatasets => [...prevDatasets, newObject]);

            }
        } else {
            setDASDData([]);

        }
    };

    // End Handle After Api Call


    // Handle Popup Call
   useEffect(() => {
    const fetchDataAndHandlePopup = async () => {
        if (popup && selectedPlot) {
            console.log(selectedPlot);
            console.log("ssssssssssssssssssssssssss",selected[0].value);
           

            if (selected[0].value === '15') {
                console.log("value$$", selectedPlot.features[0].values_.total);
                console.log("stateCode!!!", selectedPlot.features[0].values_.stateCode);

                if (selectedPlot.features[0].values_.total) {
                   
                    try {
                        const resultRKVYStateWise = await RKVYFetchDataStateWise(selectedPlot.features[0].values_.stateCode);
                        console.log('resultRKVYStateWise', resultRKVYStateWise.data);

                        if (resultRKVYStateWise.data.recordCount > 0) {
                            setDatasets([]);
                            const newObject = {
                                responseArray: resultRKVYStateWise.data.dataContent,
                                selectedValue: '11',
                                markerStyle: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAX9JREFUeNqs1c0rBHEcx3G7aw/roUjkIAfclMISJ3siDpw8lBtypRwclIeslIQbITmI4mRLKYo8pJQcaP8E5aEtF8U2xnvqO5qm34xZu7967e7M/Oaz39/D7Pp0Xc/KZMs2XlZikb/65WEH95hx6+i3HRfgEOfokXNlOEUXprEMn9fAIDrQgk9USngjOjGLUewi5DhkSwsgiTG84hbGJIdRKkFPWJXjbry5VWjc3Ic4zpBAPepwJOcuZPgRqb7CLfAZRTjBDZoxgA25blR1jQ80oRyX8lkZGMUWDqSKeUwqFu4YVaiFJpW2WQNzJGgCSxjGHoYcFjMg26gXDXiQLxk0F2Ud/RK4LUMOe9jHcyhBu4xq0wzcxxXW8IjqFB6OEdlurRg3A2PyXiwTnWqrke0W9SsuJv8R+OW0ymk31cZO/9fG0lQP/R0WLNcKsYhcL4GqFpddYL1nyilQNYdB23G+4kkJORVmr/AbL7aVfrf10aSPZjmX+J2zTP8F/AgwADpHUEvLzL+vAAAAAElFTkSuQmCC',
                                schemename: 'RKVY',
                            };
                            console.log("newObject", newObject);
                             setDatasets((prevDatasets) => {
                                // Add the new object to the existing datasets array
                                const updatedDatasets = [...prevDatasets, newObject];
                                
                                return updatedDatasets;
                            });

                           setSelected([{ label: "RKVY", value: "44" }]);
                          
                        }


                        
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                }
            } else if(selected[0].value === '44'){
                 try {
                        const FetchRKVYDetailIdWise = await RKVYInfoFetchData(selectedPlot.id);
                        console.log('FetchRKVYDetailIdWise-------------',FetchRKVYDetailIdWise.data.dataContent)
                       
                        if (FetchRKVYDetailIdWise.data.recordCount > 0) {
                         
                           const details = FetchRKVYDetailIdWise.data.dataContent;
                            handleMarkerClickCotton(selected, details, openMandtPopup);
                          
                        }
                        
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }

            }else if(selected[0].value === '13'){
                
                 try {
                        const SHCFarmerDetailsWise = await SHCFarmerDetails(selectedPlot.farmerId);
                        console.log('FetchRKVYDetailIdWise-------------',SHCFarmerDetailsWise.data.data)
                       
                        if (SHCFarmerDetailsWise.data.recordCount > 0) {
                          
                           const details = SHCFarmerDetailsWise.data.data[0];
                            handleMarkerClickCotton(selected, details,openMandtPopup);
                          
                        }
                        
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }

            }else if(selected[0].value === '28'){
               // alert('in')
                 handleMarkerClickCotton(selected, selectedPlot, openMandtPopup);
            } else if(selected[0].value === '21'){
                

                 try {
                        const seedDeailsData = await seedDeails(selectedPlot.id);
                        console.log('FetchRKVYDetailIdWise-------------',seedDeailsData.data.dataContent)
                       //alert(seedDeailsData.data.recordCount);
                        if (seedDeailsData.data.recordCount > 0) {
                          //alert(selectedPlot.id);
                           const details = seedDeailsData.data.dataContent[0];
                            handleMarkerClickCotton(selected, details,openMandtPopup);
                          
                        }
                        
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }

            }else{
                handleMarkerClickCotton(selected, selectedPlot, openMandtPopup);
            }
        }
    };

    fetchDataAndHandlePopup();
}, [popup, selectedPlot]);


    function handleAddMarker() {
        //alert('in');
        setDatasets([]);
        setMissingSchemes([]);
        document.getElementById("infoDetailsCotton").style.display = "none";
        setUserVisible(false)
        document.getElementById("counts").style.display = "none";
        selected.map((item) => {

        })
        console.log("selected12345t66666-----------------",selected);
        setVisible(true)
        setFilterCall(true);
        //  handleAddDataACABC();
        handleAddDataPatanjali();
        handleAddDataPalmOil();
        handleAddDataNMEOOP();
        handleAddDataNMEOOS();
        handleAddDataRKVYDeatils();
        handleAddDataGT();
        handleAddDataKECultivation();
        handleAddDataACABCNew();
        handleAddDataAIF();
        handleAddDataAgroforestry();
        handleAddDataAMI();
        handleAddDataMANDT();
        handleAddDataNBHM();
        handleAddDataNFSM();
        handleAddDataNHB();
        handleAddDataPDMC();
        handleAddDataRAD();
        handleAddDataSTLLab();
        handleAddDataSHCFarmer();
        handleAddDataCropic();
        handleAddDataRKVY();
        handleAddDataNaturalFarming();
        handleAddDataMIDH();
        handleAddDataMOVCD();
        handleAddDataNPSS();
        handleAddDataCotton();
        handleAddDataSeedHub();
        handleAddDataCDB();
        handleAddDataDASD();
       
    }

    //  const kmlUrls = [];
    // // Example usage
    const kmlUrls = [
        // 'https://km.amnex.co.in/pdf/ArunachalPradeshConvertedPlots.kml',
        // 'https://km.amnex.co.in/pdf/ArunachalPradeshProspectivePlots.kml',
        //  'https://km.amnex.co.in/pdf/AP_4_VZM-Nellore-Chittor-Nandyal-Turupathi-Krishna-guntur.kml',
        //  'https://km.amnex.co.in/pdf/Assam_ARP_KML_File.kml',
        //  'https://km.amnex.co.in/pdf/Karnataka_KML_File.kml',
    ];

    useEffect(() => {
    if (!selected || selected.length === 0) {
        setDatasets([]);
    }
}, [selected]);

    useEffect(() => {

const zoomOut = () => {
    const view = map.getView();
    const zoom = view.getZoom();
    view.setZoom(zoom - 1); // Decrease zoom level
};


        const scaleLineControl = new ScaleLine({ units: 'metric' });

        let layers = null
        layers = createMapLayers(datasets, satelliteLayer, kmlUrls);

             const map = new Map({
          target: mapRef.current,
          layers: layers,
          view: new View({
              projection: 'EPSG:3857',
              center: fromLonLat([78.9629, 20.5937]), // Center of India
              zoom: 4.2,
             
              
          }),
          controls: defaultControls().extend([
              new Zoom(),
              new FullScreen(),
              new ZoomToExtent({ extent: indiaExtent }),
          ]),
      });

        // Create a popup overlay
        const popupContainer = document.getElementById('popup');
        const popupOverlay = new Overlay({
            element: popupContainer,
            positioning: 'bottom-center',
            stopEvent: true,
        });
        map.addOverlay(popupOverlay);

        // Handle marker click
        map.on('singleclick', (evt) => {
            const feature = map.forEachFeatureAtPixel(evt.pixel, (feat) => feat);
            if (feature) {
                const coordinates = feature.getGeometry().getCoordinates();

                setSelectedPlot(feature.getProperties());
                popupOverlay.setPosition(coordinates);

                setPopup(true);
            } else {
                setPopup(false);
            }
        });

        // Cleanup on component unmount
        return () => {
            map.setTarget(undefined);
        };
    }, [apisuccess, datasets]);
    function getPolygonCenter(coordinates) {
    let x = 0, y = 0, n = coordinates.length;
    coordinates.forEach(([lon, lat]) => {
        x += lon;
        y += lat;
    });

    return [x / n, y / n]; // Return centroid coordinates
}
const createMapLayers = (datasets, satelliteLayer, kmlUrls) => {
  // 1. Initialize layers array with base layers
  const baseLayers = [satelliteLayer];

  // Create a separate array for mask and overlay layers
  const overlayLayers = [];

  // 2. Create India mask using local state boundary file
  try {
    // Use local state boundary file from public folder (synchronous)
    const xhr = new XMLHttpRequest();
    xhr.open('GET', '/stateboundary.json', false);
    xhr.send(null);
    
    if (xhr.status === 200) {
      const indiaStateGeoJSON = JSON.parse(xhr.responseText);
      
      // Create world polygon
      const worldCoords = [
        [-180, -90], [180, -90], [180, 90], [-180, 90], [-180, -90]
      ].map(coord => fromLonLat(coord));

      // Extract all state polygons
      const indiaPolygons = [];
      
      indiaStateGeoJSON.features.forEach(feature => {
        if (feature.geometry.type === 'MultiPolygon') {
          feature.geometry.coordinates.forEach(polygon => {
            const convertedPolygon = polygon[0].map(coord => {
              return fromLonLat([coord[0], coord[1]]);
            });
            indiaPolygons.push(convertedPolygon);
          });
        } else if (feature.geometry.type === 'Polygon') {
          const convertedPolygon = feature.geometry.coordinates[0].map(coord => {
            return fromLonLat([coord[0], coord[1]]);
          });
          indiaPolygons.push(convertedPolygon);
        }
      });

      // Create holes for all state polygons
      const holes = indiaPolygons.map(polygon => {
        return polygon.slice().reverse();
      });

      // Create mask geometry with all holes
      const maskGeometry = new Polygon([
        worldCoords,
        ...holes
      ]);

      // Add white mask layer to OVERLAY layers (not base layers)
      overlayLayers.push(new VectorLayer({
        source: new VectorSource({
          features: [new Feature({
            geometry: maskGeometry,
            name: 'india-state-mask'
          })]
        }),
        style: new Style({
          fill: new Fill({
            color: [255, 255, 255, 1]
          }),
          stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0)',
            width: 0
          })
        }),
        zIndex: 90,
        renderBuffer: 1000
      }));

      // Add state boundary outlines to OVERLAY layers
      const outlineSource = new VectorSource();
      
      indiaStateGeoJSON.features.forEach(feature => {
        // Get the actual state name from the STATE property
        const stateName = feature.properties.STATE;
        
        if (feature.geometry.type === 'MultiPolygon') {
          feature.geometry.coordinates.forEach(polygon => {
            const coords = polygon[0].map(coord => fromLonLat([coord[0], coord[1]]));
            outlineSource.addFeature(new Feature({
              geometry: new LineString(coords),
              stateName: stateName
            }));
          });
        } else if (feature.geometry.type === 'Polygon') {
          const coords = feature.geometry.coordinates[0].map(coord => fromLonLat([coord[0], coord[1]]));
          outlineSource.addFeature(new Feature({
            geometry: new LineString(coords),
            stateName: stateName
          }));
        }
      });

      overlayLayers.push(new VectorLayer({
        source: outlineSource,
        style: new Style({
          stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.7)',
            width: 1.5
          })
        }),
        zIndex: 91
      }));


    } else {
      throw new Error('Failed to load state boundary file');
    }
  } catch (error) {
    console.error("Error creating state boundary mask:", error);
    
    // Fallback: Use a simple bounding box if local file fails
    const indiaBbox = [67.0, 6.0, 98.0, 38.0];
    const worldCoords = [
      [-180, -90], [180, -90], [180, 90], [-180, 90], [-180, -90]
    ].map(coord => fromLonLat(coord));
    
    const indiaCoords = [
      [indiaBbox[0], indiaBbox[1]],
      [indiaBbox[2], indiaBbox[1]],
      [indiaBbox[2], indiaBbox[3]],
      [indiaBbox[0], indiaBbox[3]],
      [indiaBbox[0], indiaBbox[1]]
    ].map(coord => fromLonLat(coord));
    
    const maskGeometry = new Polygon([worldCoords, indiaCoords]);
    
    overlayLayers.push(new VectorLayer({
      source: new VectorSource({
        features: [new Feature({
          geometry: maskGeometry,
          name: 'india-mask-fallback'
        })]
      }),
      style: new Style({
        fill: new Fill({
          color: [255, 255, 255, 1]
        }),
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0)',
          width: 0
        })
      }),
      zIndex: 90,
      renderBuffer: 1000
    }));
  }

  // 3. Process datasets - add to OVERLAY layers
  datasets.forEach(({ responseArray, markerStyle, selectedValue }) => {
    if (selectedValue === '28') {
      // Handle Patanjali data
      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: responseArray.features.flatMap((feature) => {
            const features = [];
            const coords = feature.geometry.coordinates[0];
            
            if (coords.length > 0) {
              const polyCoords = coords.map(c => fromLonLat([c[0], c[1]]));
              polyCoords.push(polyCoords[0]);
              
              const polyFeature = new Feature({
                geometry: new Polygon([polyCoords]),
              });
              
              polyFeature.setStyle(new Style({
                stroke: new Stroke({ color: '#ff0000', width: 2 }),
                fill: new Fill({ color: 'rgba(255, 204, 51, 0.2)' })
              }));
              
              polyFeature.setProperties({
                ...feature.properties,
                geometryType: 'polygon'
              });
              
              features.push(polyFeature);

              const center = getPolygonCenter(polyCoords);
              if (center) {
                const pointFeature = new Feature({
                  geometry: new Point(center),
                });
                
                pointFeature.setStyle(new Style({
                  image: new Icon({ src: markerStyle, scale: 1.0 })
                }));
                
                pointFeature.setProperties({
                  ...feature.properties,
                  geometryType: 'point'
                });
                
                features.push(pointFeature);
              }
            }
            return features;
          }),
        }),
        zIndex: 9999
      });
      overlayLayers.push(vectorLayer);
    }
    else if (selectedValue === '24') {
      // Handle NMEO data
      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: responseArray.flatMap(plot => 
            plot.farmerLandDetailsModel?.map(landDetail => {
              const features = [];
              
              // Handle Polygon
              if (landDetail.polygonData?.coordinates?.[0]) {
                const polyCoords = landDetail.polygonData.coordinates[0]
                  .map(c => fromLonLat([c[1], c[0]]));
                
                if (polyCoords.length > 0) {
                  polyCoords.push(polyCoords[0]);
                  
                  const polyFeature = new Feature({
                    geometry: new Polygon([polyCoords]),
                  });
                  
                  const isProspective = landDetail.isProspective === "True";
                  polyFeature.setStyle(new Style({
                    fill: new Fill({
                      color: isProspective ? 'rgba(0, 150, 64, 0.1)' : 'rgba(255, 0, 0, 0.1)'
                    }),
                    stroke: new Stroke({
                      color: isProspective ? '#009640' : '#ff0000',
                      width: 2
                    }),
                    text: new Text({
                      text: landDetail.plantationDetailsModel?.[0]?.numberOfPlants?.toString() || '',
                      font: '9px sans-serif',
                      fill: new Fill({ color: '#fff' }),
                      stroke: new Stroke({ color: '#000', width: 2 })
                    })
                  }));
                  
                  polyFeature.setProperties({
                    ...plot,
                    ...landDetail,
                    geometryType: 'polygon'
                  });
                  
                  features.push(polyFeature);
                }
              }

              // Handle Point
              const lat = landDetail.geoTagging?.latitude;
              const lng = landDetail.geoTagging?.longitude;
              if (lat && lng) {
                const pointFeature = new Feature({
                  geometry: new Point(fromLonLat([lng, lat])),
                });
                
                pointFeature.setStyle(new Style({
                  image: new Icon({ src: markerStyle, scale: 1.0 })
                }));
                
                pointFeature.setProperties({
                  ...plot,
                  geometryType: 'point'
                });
                
                features.push(pointFeature);
              }
              
              return features;
            })?.flat() || []
          ),
        }),
        zIndex: 9999
      });
      overlayLayers.push(vectorLayer);
    }
    else {
      // Handle other cases
      displaySchemeMapDetails(responseArray, markerStyle, selectedValue, overlayLayers);
    }
  });

  // 4. Add KML layers if any - add to OVERLAY layers
  kmlUrls?.forEach(url => {
    const kmlLayer = new VectorLayer({
      source: new VectorSource({
        url: url,
        format: new KML()
      }),
      zIndex: 100
    });
    overlayLayers.push(kmlLayer);
  });

  // Return both base layers and overlay layers
  return [...baseLayers, ...overlayLayers];
};

    return (
        <>
         <div className="mapbg">

         <div className="headername">
      <div className="d-flex justify-content-center align-items-center">
      <div className="col-md-12">
      <h2 className="leftspcing"> GIS Dashboard</h2>
        <div class="dashbordbtn">
<Link className="btn btn-success bhuvan me-2" to="/AdminAccess"><i class="bi bi-graph-up"></i> Dashboard</Link>
{/* <Link   onClick={() => bhuvanDisplay()}  class="btn btn-success bhuvan me-2" to="/GIS"><i class="bi bi-pin-map"></i> Bhuvan</Link> */}
</div>
        <ol className="breadcrumb mapbreadcrumbs leftspcing">
                                <li className="breadcrumb-item">Admin</li>
                                <li className="breadcrumb-item active">GISDashboard</li>
                            </ol>
      


      </div>
      </div>
        </div>
            {loader === false ? "" : <div class="overlay">
                <div class="overlay__inner">
                    <div class="overlay__content"><span class="spinner"></span></div>
                </div>
            </div>}

<div className="old_filterbuttonwrp negiscss">
<button 
  type="button" 
  className="btn btn-primary filterbtn" 
  onClick={() => setUserVisible(prev => !prev)}
>
  <i className="bi bi-funnel"></i> Filter
</button>

{selected.length > 0 && !selected.some(scheme => scheme.value === "29") && datasets?.length > 0  &&

<button 
  type="button" 
  className="btn btn-primary filterbtn" 
  onClick={() => {
    if (showAnalytics) {
      // Going back to Map - only reload if we have a valid scheme selected
      if (selectedScheme && selectedScheme !== "0") {
        setDatasets([]); // Clear dataset to reload map properly
        setTimeout(() => {
          handleAddMarker();
        }, 100); // Small delay to ensure state is updated
      }
    }
    setShowAnalytics(prev => !prev); // Toggle view
  }}
>
  {showAnalytics ? "Map" : "Analytics"}
</button>

}


{userVisible && (
<aside id="myDIV" className="newmapsidebar">

<div className="container">
    <div className="row d-flex justify-content-center">
       
        <div className="col-md-12">
            <label htmlFor="inputScheme" className="form-label">
                Scheme
            </label>
            <MultiSelect
                options={optionsScheme}
                value={selected}
                onChange={setSelected}
                labelledBy={"Select"}
                isCreatable={true}
                className="schemeSelect"
                id="schemeSelect"
            // className="form-select"
            />
        </div>
       { selected.some(el => el.value === "1") && selected.length !== 26 ? (
          <div className="col-md-12">
            <label htmlFor="acabcFilter" className="form-label" id="acabcFilterLabel">
              ACABC 
            </label>
            <select
              id="acabcFilter"
              required
              className="form-select"
              onChange={(e) => setAcabcFilter(e.target.value)}
              value={acabcFilter}
              name="acabcFilter"
            >
              <option defaultValue value="NA">Choose...</option>
              <option value="1">Nodal Training Institute</option>
              <option value="2">Agriventure</option>
            </select>
          </div>
        ) : null}

       { selected.some(el => el.value === "5") && selected.length !== 26 ? (
          <div className="col-md-12">
            <label htmlFor="mandtFilter" className="form-label" id="mandtFilterLabel">
              M&T-CHC
            </label>
            <select
              id="mandtFilter"
              required
              className="form-select"
              onChange={(e) => setMandtFilter(e.target.value)}
              value={mandtFilter}
              name="mandtFilter"
            >
              <option defaultValue value="NA">Choose...</option>
              <option value="1">Source of Registration FarmsApp</option>
              <option value="2">Source of Registration FMDBT (KM)</option>
            </select>
          </div>
        ) : null}

       {selected.some(el => el.value === "6") && selected.length !== 26 ? (
          <div className="col-md-12">
            <label htmlFor="inputScheme" className="form-label">
              NBHM
            </label>
            <MultiSelect
              options={optionsNBHM}
              value={selectedNBHM}
              onChange={setSelectedNBHM}
              labelledBy={"Select"}
              isCreatable={true}
              className="NBHMSelect"
              id="NBHMSelect"
            />
          </div>
        ) : null}

        
      {["24", "25", "28"].includes(selected?.[0]?.value) && (
          <div className="col-md-12">
            <div className='row'>
            <label htmlFor="State" className="form-label" id="StateLabel">
              Company Name
            </label>
            <select
              id="company_name"
              required
              className="form-select"
              onChange={handleNMEOComapny} // Trigger a function to handle changes
              value={selectedCompany} // Dynamically set the selected value
              name="stateCode"
            >
              <option value="NA">Choose...</option>
              <option value="25">KE Cultivation Pvt Ltd</option>
              <option value="24">3F</option>
              <option value="27">Godrej</option>
              <option value="28">Patanjali</option>
            </select>
          </div></div>
        )}



         { /*{selected?.[0]?.value === "24"  && (
            <div className="col-md-12">
            <label htmlFor="State" className="form-label" id="StateLabel">
                Perspective
            </label>
            <select
                id="company_name"
                required
                className="form-select"
                onClick={getStates}
                onChange={handleNMEOComapny}
                value={selectedCompany} // Dynamically set the selected value
                name="stateCode"
            >
                <option value="NA">Choose...</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
               
            </select>
        </div>

         )}*/}
        
         
        <div className="col-md-12">
            <label htmlFor="State" className="form-label" id="StateLabel">
                State
            </label>
            <select
                id="State"
                required
                className="form-select"
                onClick={getStates}
                onChange={(e) => handleState(e.target.value)}
                value={stateValue}
                name="stateCode"
            >
                <option defaultValue value="NA">Choose...</option>
                {statesData
                    ? statesData.map((item, id) => {
                        return (
                            <option key={id} value={item.stateCode}>
                                {" "}
                                {item.stateName}
                            </option>
                        );
                    })
                    : ""}
            </select>
        </div>
        <div className="col-md-12">
            <label htmlFor="District" className="form-label" id="DistrictLabel">
                District
            </label>
            <select
                id="District"
                className="form-select"
                onChange={(e) => handleSubDistrict(e.target.value)}
                value={districtValue}
            >
                <option defaultValue value="NA">
                    Choose...
                </option>

                {districtData
                    ? districtData.map((item, id) => {
                        return (
                            <option key={id} value={item.districtCode}>
                                {" "}
                                {item.districtName}
                            </option>
                        );
                    })
                    : ""}
            </select>
        </div>
       

    </div>
    <div className="col-md-12 d-flex justify-content-center">


        {" "}







        <button
            className="btn btn-primary leftbhuvan mt-3"
            onClick={handleAddMarker}
        >
            {" "}
            <i class="bi bi-search"></i> Search
        </button>
        &nbsp;&nbsp;
        <button
            className="btn btn-primary leftbhuvan mt-3 ml-5"
            onClick={handleClear}
        >
            <i className="bi bi-arrow-clockwise"></i> Reset
        </button>

     
    </div>
    
    
</div>
</aside>
)}

</div>
         
          


            <div className="page-wrapper chiller-theme toggled">

            <div className="d-flex justify-content-center align-items-center">
            <div className="container-fluid">

             
                   
                    <div className="container-fluid ">
                        <div className="card newmapbox">
                          <div className="card-body">
                            <div id="infoDetailsCotton" className="dsfsd"></div>
                            {!showAnalytics && (
                            <div className="mainmap_box">
                              <div ref={mapRef}  className='mapboxsize'  />
                              {!visible || datasets?.[0]?.responseArray?.length > 0 && selected[0]?.value === "15" && (
                              <Draggable>
                                  <div
                                    className="Analyticsbox"
                                    style={{
                                      position: "absolute", // Important for dragging
                                     top: "465px",
                                      right: "24px",
                                      zIndex: 1000,
                                      cursor: "move", // Visual cue
                                      height: "254px"
                                    }}
                                  >
                                  <button

                                        onClick={() => setVisible(false)}
                                        style={{
                                          background: "transparent",
                                          border: "none",
                                          fontSize: "18px",
                                          cursor: "pointer",
                                          lineHeight: "1",
                                        }}
                                        aria-label="Close"
                                      >
                                        ✕
                                      </button>
                                    <h2>Survey Count<button
                                        onClick={() => setVisible(false)}
                                        style={{
                                          top: "12px",
                                          color: "#fff",
                                          position: "absolute",
                                          right: "7px",
                                          background: "transparent",
                                          border: "none",
                                          fontSize: "18px",
                                          cursor: "pointer",
                                          lineHeight: "1",
                                          fontWeight: 1000
                                        }}
                                        aria-label="Close"
                                      >
                                        ✕
                                      </button></h2>
                                    
                                    <div className="table-scroll">
                                      <table class="table table-bordered table-striped">
                                <thead class="table-light">
                                  <tr>
                                    <th className="boxtable2">S.No</th>
                                        <th className="boxtable">Scheme Name</th>
                                        <th className="boxtable">Total Count</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>{selected[0].label}</td>
                                    <td>
                                      {datasets[0].responseArray.reduce(
                                        (sum, item) => sum + (parseFloat(item.total) || 0),
                                        0
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                                    </div>
                                  </div>
                                </Draggable>
                                )}

                                {!visible || datasets?.length > 0 && selected[0]?.value === "28" && (
                                  <Draggable>
                                  <div
                                    className="Analyticsbox"
                                    style={{
                                      position: "absolute", // Important for dragging
                                      top: "465px",
                                      right: "24px",
                                      zIndex: 1000,
                                      cursor: "move", // Visual cue
                                      height: "254px"
                                    }}
                                  >
                                  <button
                                        onClick={() => setVisible(false)}
                                        style={{
                                          top: "12px",
                                          color: "#fff",
                                          position: "absolute",
                                          right: "7px",  
                                          background: "transparent",
                                          border: "none",
                                          fontSize: "18px",
                                          cursor: "pointer",
                                          lineHeight: "1",
                                          fontWeight: 1000

                                        }}
                                        aria-label="Close"
                                      >
                                        ✕
                                      </button>
                                    <h2>Survey Count</h2>
                                     
                                    <div className="table-scroll">
  <table className="table table-bordered table-striped">
    <thead className="table-light">
      <tr>
        <th className="boxtable2">S.No</th>
        <th className="boxtable">Scheme Name</th>
        <th className="boxtable1">Total Count</th>
      </tr>
    </thead>
    <tbody>
      {(() => {
        // Group datasets by scheme name to avoid duplicates
        const schemeGroups = {};
        
        datasets.forEach((dataset) => {
          let schemeName;
          let count;
          
          // Handle NBHM schemes
          if (dataset.selectedValue === "6") {
            const nbhmTypes = {
              "1": { name: "Honey Processing Unit", marker: DarkGreenMarker },
              "2": { name: "Honey Testing Unit", marker: BlueMarker },
              "3": { name: "Honey CHC", marker: LitegreenMarker },
              "4": { name: "Beeflora Plantation", marker: LightPurpleMarker }
            };
            
            const typeCode = dataset.responseArray[0]?.orgTypeCode || 
                             dataset.schemename.split('-')[1]?.trim();
            schemeName = nbhmTypes[typeCode]?.name || 'NBHM - Unknown Type';
            count = dataset.responseArray?.length || 0;
          } 
          // Handle Patanjali
          else if (dataset.selectedValue === "28") {
            schemeName = "Patanjali";
            count = dataset.responseArray?.features?.length || 0;
          }
          // Handle other schemes
          else {
            schemeName = dataset.schemename;
            count = dataset.responseArray?.length || 0;
          }
          
          // Group counts by scheme name
          if (!schemeGroups[schemeName]) {
            schemeGroups[schemeName] = {
              name: schemeName,
              count: 0,
              marker: dataset.markerStyle,
              selectedValue: dataset.selectedValue
            };
          }
          schemeGroups[schemeName].count += count;
        });
        
        // Convert to array and render
        return Object.values(schemeGroups).map((scheme, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td
              onClick={() => {
                if (stateValue === '') {
                  if (scheme.selectedValue === "6") {
                    // Handle NBHM top states differently if needed
                  } else {
                    handleShowTopStates(scheme);
                  }
                }
              }}
              style={{
                cursor: stateValue === '' ? "pointer" : "default",
                color: "#000"
              }}
              title={stateValue === '' ? "Top 5 States" : ""}
            >
              <img src={scheme.marker} alt="Scheme Marker" />
              &nbsp;&nbsp;{scheme.name}
            </td>
            <td>{scheme.count}</td>
          </tr>
        ));
      })()}
    </tbody>
  </table>
</div>
                                  </div>
                                </Draggable>
                                )}

                               {!visible ||datasets?.length > 0 && selected[0]?.value !== "15" && selected[0]?.value !== "28" && (
                                                                 <Draggable>
                                                                 <div
                                                                   className="Analyticsbox"
                                                                   style={{
                                                                     position: "absolute", // Important for dragging
                                                                     top: "465px",
                                                                     right: "24px",
                                                                     zIndex: 1000,
                                                                     cursor: "move", // Visual cue
                                                                     height: "254px"
                                                                   }}
                                                                 >
                                                                 <button
                               
                                                                       onClick={() => setVisible(false)}
                                                                       style={{
                                                                         top: "12px",
                                                                         color: "#fff",
                                                                         position: "absolute",
                                                                         right: "7px",  
                                                                         background: "transparent",
                                                                         border: "none",
                                                                         fontSize: "18px",
                                                                         cursor: "pointer",
                                                                         lineHeight: "1",
                                                                         fontWeight: 1000,
                               
                                                                       }}
                                                                       aria-label="Close"
                                                                     >
                                                                       ✕
                                                                     </button>
                                                                   <h2>Survey Count</h2>
                               
                                                                   <div className="table-scroll">
                                                                     <table class="table table-bordered table-striped">
                                                                       <thead class="table-light">
                                                                         <tr>
                                                                           <th className="boxtable2">S.No</th>
                                                                           <th className="boxtable">Scheme Name</th>
                                                                           <th className="boxtable1">Total Count</th>
                                                                         </tr>
                                                                       </thead>
                                                                     <tbody>
  {datasets.map((dataset, index) => {
    console.log("datasetdataset", dataset);
    const selectedValue = dataset.selectedValue;
    const count =
      selectedValue === "28"
        ? dataset.responseArray?.features?.length || 0
        : dataset.responseArray?.length || 0;

    const schemeName =
      selectedValue === "28"
        ? "Patanjali"
        : dataset.responseArray?.[0]?.gisSchemeName || "N/A";

    const schemeCode = dataset.responseArray?.[0]?.gisSchemeCode || "N/A";
    const selectedSchemeShow = dataset?.schemename || "N/A";
    const selectedSchemeImgShow = dataset?.markerStyle || "N/A";

    // ====== NEW: Special handling for NBHM sub-schemes ======
    if (selectedValue === "6") {
      const nbhmTypes = {
        "1": { name: "Honey Processing Unit", marker: DarkGreenMarker },
        "2": { name: "Honey Testing Unit", marker: BlueMarker },
        "3": { name: "Honey CHC", marker: LitegreenMarker },
        "4": { name: "Beeflora Plantation", marker: LightPurpleMarker }
      };
      
      const typeCode = dataset.responseArray[0]?.orgTypeCode || 
                      dataset.schemename.split('-')[1]?.trim();
      const displayName = nbhmTypes[typeCode]?.name || "NBHM";
      const marker = nbhmTypes[typeCode]?.marker || BlueMarker;

      return (
        <tr key={index}>
          <td
            onClick={stateValue === '' ? () => handleShowTopStates(dataset) : undefined}
            style={{
              cursor: stateValue === '' ? "pointer" : "default",
              color: "#000"
            }}
            title={stateValue === '' ? "Top 5 States" : ""}
          >
            {index + 1}
          </td>
          <td
            onClick={stateValue === '' ? () => handleShowTopStates(dataset) : undefined}
            style={{ cursor: "pointer", color: "#000" }}
            title={stateValue === '' ? "Top 5 States" : ""}
          >
            <img src={marker} alt="NBHM Icon" />
            &nbsp;&nbsp;{displayName}
          </td>
          <td>{count}</td>
        </tr>
      );
    }
    // ====== END OF NBHM MODIFICATION ======

    if (selectedValue === "28") {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td><img src={selectedSchemeImgShow} alt="Count Icon" />&nbsp;&nbsp;{schemeName}</td>
          <td>{count}</td>
        </tr>
      );
    }

    return (
      <tr key={index}>
        <td
          onClick={stateValue === '' ? () => handleShowTopStates(dataset) : undefined}
          style={{
            cursor: stateValue === '' ? "pointer" : "default",
            color: "#000"
          }}
          title={stateValue === '' ? "Top 5 States" : ""}
        >
          {index + 1}
        </td>

        {stateValue !== '' ? (
          <td
            onClick={() => handleShowOneScheme(schemeCode, schemeName)}
            style={{ cursor: "pointer", color: "#000" }}
            title="Top 5 States"
          >
            <img src={selectedSchemeImgShow} alt="Count Icon" />
            &nbsp;&nbsp;
            {schemeCode === 1 ? selectedSchemeShow : schemeName}
          </td>
        ) : (
          <td
            onClick={() => handleShowTopStates(dataset)}
            style={{ cursor: "pointer", color: "#000" }}
            title="Top 5 States"
          >
            <img src={selectedSchemeImgShow} alt="Count Icon" />
            &nbsp;&nbsp;
            {schemeCode === 1 ? selectedSchemeShow : schemeName}
          </td>
        )}

        <td>{count}</td>
      </tr>
    );
  })}
</tbody>                    
                               
                                                                     </table>
                                                                   </div>
                                                                 </div>
                                                               </Draggable>
                                                               )}

                            </div>
                            )}
                            {showAnalytics && (
                              <div className="analytics-dashboard">
                                {/*<h3>Analytics Dashboard</h3>*/}
                                {/* Add your charts, tables, etc. here */}
                                <YearlyChart datasets={datasets} />
                                <SchemeStateLineChart datasets={datasets} />
                                <SchemePieChart datasets={datasets} />

                              </div>
                            )}
                          </div>
                        </div>
                       
                    </div>
                </div>
                </div>
            </div>

             <div className="modal fade" id="counts" tabindex="-1" aria-labelledby="exampleModalLabell" aria-hidden="true">
              <div className="modal-dialog dataCountResult">
                <div className="modal-content">
                                 <div className="modal-header d-flex justify-content-between align-items-center">
                    <h5 className="modal-title w-100 text-center">
                        <b>Total Records</b>
                    </h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                </div>
                  <div className="modal-body" id="count">
                    {datasets?.[0]?.responseArray?.length > 0 && selected[0]?.value === '15' && (
                      <div className="d-flex justify-content-between" key={selected[0].value}>
                        <span>
                          {`${selected[0].label} :- ${datasets[0].responseArray.reduce((sum, item) => sum + (parseFloat(item.total) || 0), 0)}`}
                        </span>
                        &nbsp;&nbsp;&nbsp;
                      </div>
                    )}
                    
                     {datasets?.length > 0 && selected[0]?.value != '15' && selected[0]?.value != '28' &&
                      datasets.map((dataset, index) => {
                        const schemeName = dataset.responseArray?.[0]?.gisSchemeName;
                        const count = dataset.responseArray?.length || 0;

                        return (
                          <div className="d-flex justify-content-between" key={index}>
                            <span>{schemeName} : {count}</span>
                          </div>
                        );
                    })}

                    {selected[0]?.value === '28' &&
                      datasets.map((dataset, index) => {
                        const schemeName = 'Patanjali';
                        const count = datasets?.[0]?.responseArray?.features?.length || 0;

                        return (
                          <div className="d-flex justify-content-between" key={index}>
                            <span>{schemeName} : {count}</span>
                          </div>
                        );
                    })}

                  </div>
                   <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                      Close
                   </button>
                              
                
                </div>
              </div>    
            </div>

            {isModalOpen && (
                  <div className="modal fade show" style={{ display: "block" }} aria-modal="true" role="dialog">
                      <div className="modal-dialog notfounddata">
                          <div className="modal-content">
                             
                               <div className="modal-body nofoundscrollbar">
                                <center><b>Data not found in:</b></center>
                                <ul>
                                    {missingSchemes.map((scheme, index) => (
                                        <li key={index}>{scheme}</li>
                                    ))}
                                </ul>
                            </div>
                                         
                                  <button type="button" className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>
                                      Close
                                  </button>
                              
                          </div>
                      </div>
                  </div>
              )}

            {isTopStatesModalOpen && (
  <div className="modal fade show" style={{ display: "block" }} aria-modal="true" role="dialog">
    <div className="modal-dialog notfounddata">
      <div className="modal-content">
        <div className="modal-body nofoundscrollbar">
          <center><h5>Top 5 States</h5></center>
          
          {/* Check if this is NBHM data (array of objects) */}
          {Array.isArray(topStates) && topStates[0]?.schemeType ? (
            topStates.map((schemeData, idx) => (
              <div key={idx}>
                <h6>{schemeData.schemeType}</h6>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                  {schemeData.topStates.map(([state, count], stateIdx) => (
                    <li key={stateIdx} style={{ padding: "10px 0" }}>
                      <strong>{stateIdx + 1}.</strong> {state} : {count}
                      {stateIdx !== schemeData.topStates.length - 1 && <hr style={{ margin: "8px 0" }} />}
                    </li>
                  ))}
                </ul>
                {idx !== topStates.length - 1 && <hr style={{ margin: "15px 0", borderTop: "2px solid #ddd" }} />}
              </div>
            ))
          ) : (
            /* Default display for non-NBHM schemes */
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {topStates.map(([state, count], idx) => (
                <li key={idx} style={{ padding: "10px 0" }}>
                  <strong>{idx + 1}.</strong> {state} : {count}
                  {idx !== topStates.length - 1 && <hr style={{ margin: "8px 0" }} />}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setIsTopStatesModalOpen(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}
             <div className="modal fade" id="dataStatus" tabindex="-1" aria-labelledby="exampleModalLabell" aria-hidden="true">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabell">Total Records</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                  </div>
                  <div className="modal-body" id="count">
                     <h3>Data not found</h3>

                  </div>
                
                </div>
              </div>    
            </div>

             <div className="modal fade" id="countsss" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Total Records</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                  </div>
                  <div className="modal-body" id="count">
                      <h3>Data not found</h3>
                  </div>
                </div>
              </div>    
            </div>



            <div className="modal fade ImageSliderPopUP" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            {/* <h5 className="modal-title" id="exampleModalLabel">AIF Survey Screens</h5> */}
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div className="modal-body">
                            <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner AIFImageSliderClass" id="AIFImageSlider">

                                </div>
                                {/* <button id="button">Click me!</button> */}
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev" id="prevBtn">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next" id="nextBtn">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>



            <div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="imageModalLabel">Images</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div class="modal-body">
                           
                            <div id="imageCarousel" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner" id="imageCarouselInner">

                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#imageCarousel" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#imageCarousel" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           
            {/* M&T Popup */}

            <div className="modal fade ImageSliderPopUP" id="exampleModalMandT" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    {/* <h5 className="modal-title" id="exampleModalLabel">AIF Survey Screens</h5> */}
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                  </div>
                  <div className="modal-body">
                  <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner" id="AIFImageSliderM&T">
                   
                  </div>

            </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>

</div>

        </>
    );
};

export default MapComponent;
